import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
};

export type Account = {
  __typename: 'Account';
  accountType: Scalars['String']['output'];
  allowedProjects?: Maybe<Scalars['JSON']['output']>;
  attachments?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabledGlobalAccess?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  expirationFlag?: Maybe<ExpirationFlag>;
  fields?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type AccountInput = {
  accountType: Scalars['String']['input'];
  allowedProjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attachments?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabledGlobalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type AccountPageable = {
  __typename: 'AccountPageable';
  content?: Maybe<Array<Maybe<Account>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AccountType = {
  __typename: 'AccountType';
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  providers?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  sensitive?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Acl = {
  __typename: 'Acl';
  id: Scalars['ID']['output'];
  realm?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Acls = {
  __typename: 'Acls';
  active?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  roles?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
};

export type AlertConfig = {
  __typename: 'AlertConfig';
  alertIntervalCheck: Scalars['String']['output'];
  alertMetricName: Scalars['String']['output'];
  alertMetricThresholdOperator: Scalars['String']['output'];
  alertMetricThresholdValue: Scalars['String']['output'];
  alertParams: Array<Maybe<AlertParams>>;
};

export type AlertConfigInput = {
  alertIntervalCheck: Scalars['String']['input'];
  alertMetricName: Scalars['String']['input'];
  alertMetricThresholdOperator: Scalars['String']['input'];
  alertMetricThresholdValue: Scalars['String']['input'];
  alertParams: Array<InputMaybe<AlertParamsInput>>;
};

export type AlertParams = {
  __typename: 'AlertParams';
  paramName: Scalars['String']['output'];
  paramType: Scalars['String']['output'];
  paramVersion?: Maybe<Scalars['Int']['output']>;
};

export type AlertParamsInput = {
  paramName: Scalars['String']['input'];
  paramType: Scalars['String']['input'];
  paramVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertsConfig = {
  __typename: 'AlertsConfig';
  alertConfig: AlertConfig;
  alertName: Scalars['String']['output'];
  alertStatus?: Maybe<Scalars['Boolean']['output']>;
  environment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationConfig: NotificationConfig;
  realm: Scalars['String']['output'];
};

export type ApiError = {
  message: Scalars['String']['output'];
};

export type ApiKeys = {
  __typename: 'ApiKeys';
  acls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  apiKeys?: Maybe<Array<Maybe<Apikey>>>;
  basicAuths?: Maybe<Array<Maybe<BasicAuth>>>;
  customId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ApiResponse = {
  error?: Maybe<ApiError>;
  success: Scalars['Boolean']['output'];
};

export type Apikey = {
  __typename: 'Apikey';
  apiKey: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  idKeyAuth: Scalars['String']['output'];
};

export type AssertionResult = {
  __typename: 'AssertionResult';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

export type Audit = {
  __typename: 'Audit';
  dateStart: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entityRealm?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  method?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  objectIdFriendlyLabel?: Maybe<Scalars['String']['output']>;
  platformUser?: Maybe<Scalars['JSON']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  sourceIp?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AuditPagination = {
  __typename: 'AuditPagination';
  content?: Maybe<Array<Maybe<Audit>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type AuthConfig = {
  __typename: 'AuthConfig';
  acls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  configVersion?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['String']['output'];
  expiresIn?: Maybe<Scalars['String']['output']>;
  expiresInDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  revoked?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BasicAuth = {
  __typename: 'BasicAuth';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type BasicAuthInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type Binding = {
  __typename: 'Binding';
  envs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role?: Maybe<Role>;
};

export type Canvas = {
  __typename: 'Canvas';
  edges?: Maybe<Array<Edge>>;
  nodes?: Maybe<Array<Node>>;
};

export type CanvasInput = {
  edges?: InputMaybe<Array<EdgeInput>>;
  nodes?: InputMaybe<Array<NodeInput>>;
};

export type Capsule = {
  __typename: 'Capsule';
  capsuleCollectionGroup?: Maybe<Scalars['JSON']['output']>;
  capsuleCollectionId: Scalars['String']['output'];
  capsuleKey: Scalars['String']['output'];
  configExample?: Maybe<Scalars['JSON']['output']>;
  configSpec?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disconnectedFlowSpecs?: Maybe<Scalars['JSON']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  errorDetail?: Maybe<Scalars['JSON']['output']>;
  flowSpec?: Maybe<Scalars['JSON']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inSpec?: Maybe<Scalars['JSON']['output']>;
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  mocks?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  outSpec?: Maybe<Scalars['JSON']['output']>;
  state: Scalars['String']['output'];
  testMode?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  versionFix: Scalars['Int']['output'];
  versionMajor: Scalars['Int']['output'];
  versionMinor: Scalars['Int']['output'];
};

export type CapsuleCatalog = {
  __typename: 'CapsuleCatalog';
  capsuleCollectionHeader?: Maybe<Scalars['JSON']['output']>;
  capsuleServices?: Maybe<Array<Maybe<CapsuleService>>>;
  colorAccent?: Maybe<Scalars['String']['output']>;
  colorBackground?: Maybe<Scalars['String']['output']>;
  colorDefault?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  realmMaintainer?: Maybe<Realm>;
  realmPrivate?: Maybe<Realm>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  versionTag?: Maybe<Scalars['String']['output']>;
};

export type CapsuleCatalogInput = {
  capsuleServices?: InputMaybe<Array<InputMaybe<CapsuleServiceInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CapsuleComponent = {
  __typename: 'CapsuleComponent';
  canvas?: Maybe<Canvas>;
  capsuleCollectionGroup?: Maybe<Scalars['JSON']['output']>;
  capsuleCollectionId: Scalars['String']['output'];
  capsuleKey: Scalars['String']['output'];
  configExample?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  documentation?: Maybe<Scalars['String']['output']>;
  errorDetail?: Maybe<Scalars['JSON']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inSpec?: Maybe<Scalars['JSON']['output']>;
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  outSpec?: Maybe<Scalars['JSON']['output']>;
  state: Scalars['String']['output'];
  testMode?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  versionFix: Scalars['Int']['output'];
  versionMajor: Scalars['Int']['output'];
  versionMinor: Scalars['Int']['output'];
};

export type CapsuleComponentInput = {
  canvas?: InputMaybe<CanvasInput>;
  capsuleCollectionGroup?: InputMaybe<Scalars['JSON']['input']>;
  capsuleCollectionId: Scalars['String']['input'];
  capsuleKey: Scalars['String']['input'];
  configExample?: InputMaybe<Scalars['JSON']['input']>;
  configSpec?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  documentation?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  jsonSchema?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  newCapsule?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  state: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testMode?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  versionFix: Scalars['Int']['input'];
  versionMajor: Scalars['Int']['input'];
  versionMinor: Scalars['Int']['input'];
};

export type CapsuleComponentPagination = {
  __typename: 'CapsuleComponentPagination';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type CapsuleInput = {
  capsuleCollectionGroup?: InputMaybe<Scalars['JSON']['input']>;
  capsuleCollectionId: Scalars['String']['input'];
  capsuleKey: Scalars['String']['input'];
  configExample?: InputMaybe<Scalars['JSON']['input']>;
  configSpec?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  disconnectedFlowSpecs?: InputMaybe<Scalars['JSON']['input']>;
  documentation: Scalars['String']['input'];
  flowSpec?: InputMaybe<Scalars['JSON']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  iconName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  jsonSchema?: InputMaybe<Scalars['JSON']['input']>;
  mocks?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  state: Scalars['String']['input'];
  stepsDocumentations?: InputMaybe<Scalars['JSON']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testMode?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  versionFix: Scalars['Int']['input'];
  versionMajor: Scalars['Int']['input'];
  versionMinor: Scalars['Int']['input'];
};

export type CapsulePagination = {
  __typename: 'CapsulePagination';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type CapsuleService = {
  __typename: 'CapsuleService';
  active?: Maybe<Scalars['Boolean']['output']>;
  canvas?: Maybe<Scalars['JSON']['output']>;
  capsule?: Maybe<ItemCapsuleCatalog>;
  capsuleCollectionGroup?: Maybe<Scalars['JSON']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionName?: Maybe<Scalars['String']['output']>;
  colorAccent?: Maybe<Scalars['String']['output']>;
  colorBackground?: Maybe<Scalars['String']['output']>;
  colorDefault?: Maybe<Scalars['String']['output']>;
  configExample?: Maybe<Scalars['JSON']['output']>;
  configSpec?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['ID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['JSON']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idCatalog?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inSpec?: Maybe<Scalars['JSON']['output']>;
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outSpec?: Maybe<Scalars['JSON']['output']>;
  realmName?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['ID']['output']>;
  shape?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionFix?: Maybe<Scalars['Int']['output']>;
  versionMajor?: Maybe<Scalars['Int']['output']>;
  versionMinor?: Maybe<Scalars['Int']['output']>;
  visual?: Maybe<Scalars['Boolean']['output']>;
};

export type CapsuleServiceInput = {
  canvas?: InputMaybe<Scalars['JSON']['input']>;
  catalog?: InputMaybe<Scalars['String']['input']>;
  configExample?: InputMaybe<Scalars['JSON']['input']>;
  configSpec?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  documentation?: InputMaybe<Scalars['String']['input']>;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newCatalog?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CapsuleUnifiedCatalog = {
  __typename: 'CapsuleUnifiedCatalog';
  active?: Maybe<Scalars['Boolean']['output']>;
  capsule?: Maybe<CapsuleService>;
  category?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionName?: Maybe<Scalars['String']['output']>;
  colorAccent?: Maybe<Scalars['String']['output']>;
  colorBackground?: Maybe<Scalars['String']['output']>;
  colorDefault?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['ID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  keyName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  realmName?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['ID']['output']>;
  shape?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionMajor?: Maybe<Scalars['String']['output']>;
  versionMinor?: Maybe<Scalars['String']['output']>;
};

export type CatalogItem = {
  __typename: 'CatalogItem';
  category?: Maybe<Scalars['String']['output']>;
  colorAccent?: Maybe<Scalars['String']['output']>;
  colorBackground?: Maybe<Scalars['String']['output']>;
  colorDefault?: Maybe<Scalars['String']['output']>;
  customMetadata?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  documentationURL?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  endpointMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endpointURL?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  environments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  versionMajor?: Maybe<Scalars['String']['output']>;
  versionMinor?: Maybe<Scalars['String']['output']>;
};

export type CatalogPageable = {
  __typename: 'CatalogPageable';
  content?: Maybe<Array<Maybe<CatalogItem>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CatalogRootQuery = {
  __typename: 'CatalogRootQuery';
  capsules?: Maybe<Array<Maybe<CapsuleUnifiedCatalog>>>;
  connectors?: Maybe<Array<Maybe<Connector>>>;
  triggers?: Maybe<Array<Maybe<TriggerCatalog>>>;
};

export type CollectionGroup = {
  __typename: 'CollectionGroup';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CollectionGroupInput = {
  title: Scalars['String']['input'];
};

export type CollectionGroupsPagination = {
  __typename: 'CollectionGroupsPagination';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type CollectionHeader = {
  __typename: 'CollectionHeader';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  realmMaintainer: Realm;
  title?: Maybe<Scalars['String']['output']>;
};

export type CollectionHeaderInput = {
  iconName: Scalars['String']['input'];
  iconURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type Component = {
  __typename: 'Component';
  badgeInfo?: Maybe<Scalars['JSON']['output']>;
  camelConnector?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionPtbr?: Maybe<Scalars['String']['output']>;
  documentation: Scalars['String']['output'];
  documentationURL?: Maybe<Scalars['String']['output']>;
  experimental?: Maybe<Scalars['Boolean']['output']>;
  icon: Scalars['String']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jsonCapsuleEnable?: Maybe<Scalars['Boolean']['output']>;
  jsonExample: Scalars['String']['output'];
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  jsonSchemaCapsule?: Maybe<Scalars['JSON']['output']>;
  jsonSchemaEdge?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  shape?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toplevelCategory?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  visual?: Maybe<Scalars['Boolean']['output']>;
};

export type Configuration = {
  __typename: 'Configuration';
  actualConsumers?: Maybe<Scalars['Int']['output']>;
  consumers?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logSensitiveFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
};

export type Connection = {
  __typename: 'Connection';
  alias?: Maybe<Scalars['String']['output']>;
  constraint?: Maybe<Constraint>;
  endpoint?: Maybe<Endpoint>;
  environment?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isInverse?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networkId?: Maybe<Scalars['String']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  remainingHsToRegister?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type Connector = {
  __typename: 'Connector';
  badgeInfo?: Maybe<Scalars['JSON']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  documentationURL?: Maybe<Scalars['String']['output']>;
  experimental?: Maybe<Scalars['Boolean']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  jsonCapsuleEnable?: Maybe<Scalars['Boolean']['output']>;
  jsonExample?: Maybe<Scalars['String']['output']>;
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  jsonSchemaCapsule?: Maybe<Scalars['JSON']['output']>;
  keyName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  shape?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Constraint = {
  __typename: 'Constraint';
  services?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Consumer = {
  __typename: 'Consumer';
  acls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  apiKeys?: Maybe<Array<Maybe<Apikey>>>;
  customId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ConsumerApikey = {
  __typename: 'ConsumerApikey';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ConsumerApikeys = {
  __typename: 'ConsumerApikeys';
  acls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  apiKeys?: Maybe<Array<Maybe<ConsumerApikey>>>;
  basicAuths?: Maybe<Array<Maybe<BasicAuth>>>;
  customId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ConsumptionBasedMetrics = {
  __typename: 'ConsumptionBasedMetrics';
  consumptionByProjects?: Maybe<Array<Maybe<ConsumptionByProject>>>;
  creditsHistory?: Maybe<Array<Maybe<CreditHistory>>>;
  metrics?: Maybe<Metrics>;
  metricsPrices?: Maybe<MetricsPrices>;
};

export type ConsumptionByProject = {
  __typename: 'ConsumptionByProject';
  environments?: Maybe<Scalars['JSON']['output']>;
  pipelines?: Maybe<Array<Maybe<ConsumptionByProjectsPipeline>>>;
  projectName?: Maybe<Scalars['String']['output']>;
  totalPipelines?: Maybe<Scalars['Int']['output']>;
};

export type ConsumptionByProjectsPipeline = {
  __typename: 'ConsumptionByProjectsPipeline';
  egress?: Maybe<Egress>;
  environment?: Maybe<Scalars['String']['output']>;
  gbSecond?: Maybe<GbSecond>;
  numberOfExecution?: Maybe<NumberOfExecution>;
  pipelineName?: Maybe<Scalars['String']['output']>;
};

export type CostPerMetric = {
  __typename: 'CostPerMetric';
  egress?: Maybe<Scalars['String']['output']>;
  gbSecond?: Maybe<Scalars['String']['output']>;
  numberExecution?: Maybe<Scalars['String']['output']>;
};

export type CreateOAuthProviderFromBaseProviderInput = {
  authURL?: InputMaybe<Scalars['String']['input']>;
  baseProvider?: InputMaybe<Scalars['String']['input']>;
  baseProviderRealm?: InputMaybe<Scalars['String']['input']>;
  certificate?: InputMaybe<Scalars['String']['input']>;
  certificatePassword?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  grantRequestBody?: InputMaybe<Scalars['JSON']['input']>;
  grantURL?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  redirect_uri?: InputMaybe<Scalars['String']['input']>;
  refreshURL?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreditHistory = {
  __typename: 'CreditHistory';
  expiryAt?: Maybe<Scalars['String']['output']>;
  granted?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum CurrencyCode {
  BRL = 'BRL',
  USD = 'USD'
}

export type DateHistogramStats = {
  __typename: 'DateHistogramStats';
  avg?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  countError?: Maybe<Scalars['Float']['output']>;
  countSuccess?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  stdDeviation?: Maybe<Scalars['Float']['output']>;
  stdDeviationLower?: Maybe<Scalars['Float']['output']>;
  stdDeviationUpper?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  sumOfSquares?: Maybe<Scalars['Float']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  variace?: Maybe<Scalars['Float']['output']>;
};

export type DeployHistory = {
  __typename: 'DeployHistory';
  deployedAt?: Maybe<Scalars['String']['output']>;
  deployedBy?: Maybe<Scalars['JSON']['output']>;
  environment?: Maybe<Environment>;
  id: Scalars['ID']['output'];
  pipeline?: Maybe<Pipeline>;
  project?: Maybe<Project>;
  runtimeConfiguration?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Array<Maybe<DeployHistoryStatus>>>;
};

export type DeployHistoryDistinct = {
  __typename: 'DeployHistoryDistinct';
  deployedAtFirst?: Maybe<Scalars['String']['output']>;
  deployedAtLast?: Maybe<Scalars['String']['output']>;
  deployedBy?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  deployedByLast?: Maybe<Scalars['JSON']['output']>;
  lastSize?: Maybe<Scalars['String']['output']>;
  lastStatus?: Maybe<Scalars['String']['output']>;
  lastStatusDate?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['String']['output']>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  pipelineVersionMajor?: Maybe<Scalars['String']['output']>;
  pipelineVersionMinor?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type DeployHistoryDistinctPageable = {
  __typename: 'DeployHistoryDistinctPageable';
  content?: Maybe<Array<Maybe<DeployHistoryDistinct>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type DeployHistoryPageable = {
  __typename: 'DeployHistoryPageable';
  content?: Maybe<Array<Maybe<DeployHistory>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type DeployHistoryStatus = {
  __typename: 'DeployHistoryStatus';
  date?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type Deployment = {
  __typename: 'Deployment';
  activeConfiguration?: Maybe<Scalars['JSON']['output']>;
  availableReplicas?: Maybe<Scalars['String']['output']>;
  deploymentStatus?: Maybe<Scalars['JSON']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  errorCount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastOMM?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  oomCount?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<Scalars['JSON']['output']>;
  project?: Maybe<Scalars['String']['output']>;
  replicaName?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  trigger?: Maybe<Scalars['JSON']['output']>;
};

export type DeploymentPageable = {
  __typename: 'DeploymentPageable';
  content?: Maybe<Array<Maybe<Deployment>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type DeploymentPlan = {
  __typename: 'DeploymentPlan';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['JSON']['output']>;
  currentEnvironments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deploymentPlanItems?: Maybe<Array<Maybe<DeploymentPlanItem>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Realm>;
};

export type DeploymentPlanItem = {
  __typename: 'DeploymentPlanItem';
  environmentConfiguration?: Maybe<Array<Maybe<EnvironmentConfiguration>>>;
  pipelineMajorVersion?: Maybe<PipelineMajorVersion>;
};

export type DeploymentPlanPageable = {
  __typename: 'DeploymentPlanPageable';
  content?: Maybe<Array<Maybe<DeploymentPlan>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type DeploymentStats = {
  __typename: 'DeploymentStats';
  DEPLOYED?: Maybe<Scalars['Int']['output']>;
  EXPIRES?: Maybe<Scalars['Int']['output']>;
  SERVICE_ACTIVE?: Maybe<Scalars['Int']['output']>;
};

export type Edge = {
  __typename: 'Edge';
  data?: Maybe<EdgeData>;
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type EdgeData = {
  __typename: 'EdgeData';
  condition?: Maybe<Scalars['String']['output']>;
  conditionRule?: Maybe<Scalars['String']['output']>;
  conditionType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  executionId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EdgeDataInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
  conditionRule?: InputMaybe<Scalars['String']['input']>;
  conditionType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executionId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EdgeInput = {
  data?: InputMaybe<EdgeDataInput>;
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

export type Egress = {
  __typename: 'Egress';
  costCurrency?: Maybe<Scalars['String']['output']>;
  spentMetric?: Maybe<Scalars['String']['output']>;
};

export type EmailParams = {
  __typename: 'EmailParams';
  emailContent?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTo: Array<Maybe<Scalars['String']['output']>>;
};

export type EmailParamsInput = {
  emailContent?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailTo: Array<InputMaybe<Scalars['String']['input']>>;
};

export type Endpoint = {
  __typename: 'Endpoint';
  alias?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  fullEndpoint?: Maybe<Scalars['String']['output']>;
  hasEdgeRouterConnection?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  online?: Maybe<Scalars['Boolean']['output']>;
  remainingHsToRegister?: Maybe<Scalars['Int']['output']>;
  triggerSpec?: Maybe<TriggerSpec>;
  versionMajor?: Maybe<Scalars['Int']['output']>;
  versionMinor?: Maybe<Scalars['Int']['output']>;
};

export type Environment = {
  __typename: 'Environment';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  retention?: Maybe<Retention>;
};

export type EnvironmentConfiguration = {
  __typename: 'EnvironmentConfiguration';
  deploymentPlanStatus?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Environment>;
  pipeline?: Maybe<Pipeline>;
  runtimeConfiguration?: Maybe<Scalars['JSON']['output']>;
};

export type EnvironmentParameterInput = {
  compound?: InputMaybe<Scalars['Boolean']['input']>;
  parameter: Scalars['String']['input'];
  privateForUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['JSON']['input'];
};

export type Event = {
  __typename: 'Event';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ExecuteMultipleTestCasesResponse = {
  __typename: 'ExecuteMultipleTestCasesResponse';
  data: Array<TestCaseResult>;
  digibeeDebug?: Maybe<Scalars['String']['output']>;
  digibeeKey?: Maybe<Scalars['String']['output']>;
};

export enum ExpirationFlag {
  CLOSE_TO_EXPIRED = 'CLOSE_TO_EXPIRED',
  EXPIRED = 'EXPIRED',
  NOT_EXPIRED = 'NOT_EXPIRED'
}

export type GbSecond = {
  __typename: 'GbSecond';
  costCurrency?: Maybe<Scalars['String']['output']>;
  spentMetric?: Maybe<Scalars['String']['output']>;
};

export type Global = {
  __typename: 'Global';
  allowedProjects?: Maybe<Scalars['JSON']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabledGlobalAccess?: Maybe<Scalars['Boolean']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  realm?: Maybe<Realm>;
  valuesByEnv?: Maybe<Scalars['String']['output']>;
};

export type GlobalInput = {
  allowedProjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabledGlobalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<RealmInput>;
  valuesByEnv?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalPageable = {
  __typename: 'GlobalPageable';
  content?: Maybe<Array<Maybe<Global>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Group = {
  __typename: 'Group';
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GroupApiError = ApiError & {
  __typename: 'GroupApiError';
  message: Scalars['String']['output'];
};

export type GroupApiResponse = ApiResponse & {
  __typename: 'GroupApiResponse';
  data?: Maybe<Array<Group>>;
  error?: Maybe<GroupApiError>;
  success: Scalars['Boolean']['output'];
};

export type GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Groups = {
  __typename: 'Groups';
  content?: Maybe<Array<Maybe<Group>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type IdPSettings = {
  __typename: 'IdPSettings';
  archived?: Maybe<Scalars['Boolean']['output']>;
  callbackURL?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idPCertificate?: Maybe<Scalars['String']['output']>;
  idPLoginURL?: Maybe<Scalars['String']['output']>;
  idPName?: Maybe<Scalars['String']['output']>;
  issuerURL?: Maybe<Scalars['String']['output']>;
  metadataURL?: Maybe<Scalars['String']['output']>;
  oauthLoginURL?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IdPSettingsApiError = ApiError & {
  __typename: 'IdPSettingsApiError';
  message: Scalars['String']['output'];
};

export type IdPSettingsData = {
  __typename: 'IdPSettingsData';
  content?: Maybe<Array<Maybe<IdPSettings>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type IdPSettingsDataApiResponse = ApiResponse & {
  __typename: 'IdPSettingsDataApiResponse';
  data?: Maybe<IdPSettingsData>;
  error?: Maybe<IdPSettingsApiError>;
  success: Scalars['Boolean']['output'];
};

export type IdPSettingsDetailsApiResponse = ApiResponse & {
  __typename: 'IdPSettingsDetailsApiResponse';
  data?: Maybe<IdPSettings>;
  error?: Maybe<IdPSettingsApiError>;
  success: Scalars['Boolean']['output'];
};

export type InflightTransaction = {
  __typename: 'InflightTransaction';
  cancelRequest?: Maybe<Scalars['String']['output']>;
  engineVersion?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  replicaName?: Maybe<Scalars['String']['output']>;
  requestMessageSize?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timeout?: Maybe<Scalars['String']['output']>;
  timestampEnd?: Maybe<Scalars['String']['output']>;
  timestampStart?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type InflightTransactions = {
  __typename: 'InflightTransactions';
  count?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Array<Maybe<InflightTransaction>>>;
};

export type IntelliSenseCompletion = {
  __typename: 'IntelliSenseCompletion';
  label?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ItemCapsuleCatalog = {
  __typename: 'ItemCapsuleCatalog';
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionName?: Maybe<Scalars['String']['output']>;
  colorAccent?: Maybe<Scalars['String']['output']>;
  colorBackground?: Maybe<Scalars['String']['output']>;
  colorDefault?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['ID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type LibraryCatalog = {
  __typename: 'LibraryCatalog';
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  libraryServices?: Maybe<Array<Maybe<LibraryService>>>;
  name?: Maybe<Scalars['String']['output']>;
  realmMaintainer?: Maybe<Realm>;
  realmPrivate?: Maybe<Realm>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  versionTag?: Maybe<Scalars['String']['output']>;
};

export type LibraryCatalogInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  libraryServices?: InputMaybe<Array<InputMaybe<LibraryServiceInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LibraryComponent = {
  __typename: 'LibraryComponent';
  canvas?: Maybe<Canvas>;
  configExample?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  documentation?: Maybe<Scalars['String']['output']>;
  errorDetail?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idCatalog: Scalars['String']['output'];
  idLib: Scalars['String']['output'];
  inSpec?: Maybe<Scalars['JSON']['output']>;
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  outSpec?: Maybe<Scalars['JSON']['output']>;
  state: Scalars['String']['output'];
  testMode?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  versionFix: Scalars['Int']['output'];
  versionMajor: Scalars['Int']['output'];
  versionMinor: Scalars['Int']['output'];
};

export type LibraryComponentInput = {
  canvas?: InputMaybe<CanvasInput>;
  configExample?: InputMaybe<Scalars['JSON']['input']>;
  configSpec?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  documentation?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idCatalog: Scalars['String']['input'];
  idLib: Scalars['String']['input'];
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  jsonSchema?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  newLibrary?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  state: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testMode?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  versionFix: Scalars['Int']['input'];
  versionMajor: Scalars['Int']['input'];
  versionMinor: Scalars['Int']['input'];
};

export type LibraryComponentPagination = {
  __typename: 'LibraryComponentPagination';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type LibraryPagination = {
  __typename: 'LibraryPagination';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type LibraryService = {
  __typename: 'LibraryService';
  canvas?: Maybe<Scalars['JSON']['output']>;
  configExample?: Maybe<Scalars['JSON']['output']>;
  configSpec?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['JSON']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idCatalog?: Maybe<Scalars['String']['output']>;
  inSpec?: Maybe<Scalars['JSON']['output']>;
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outSpec?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  versionFix?: Maybe<Scalars['Int']['output']>;
  versionMajor?: Maybe<Scalars['Int']['output']>;
  versionMinor?: Maybe<Scalars['Int']['output']>;
  visual?: Maybe<Scalars['Boolean']['output']>;
};

export type LibraryServiceInput = {
  canvas?: InputMaybe<Scalars['JSON']['input']>;
  catalog?: InputMaybe<Scalars['String']['input']>;
  configExample?: InputMaybe<Scalars['JSON']['input']>;
  configSpec?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newCatalog?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LicenseStatus = {
  __typename: 'LicenseStatus';
  licenseModel?: Maybe<Scalars['String']['output']>;
  pipelineSubscriptionAndRtu?: Maybe<Scalars['JSON']['output']>;
  totalAvailableLicenses?: Maybe<Scalars['Int']['output']>;
  totalLicensesInUse?: Maybe<Scalars['Int']['output']>;
  totalRealmLicenses?: Maybe<Scalars['Int']['output']>;
};

export type Log = {
  __typename: 'Log';
  id: Scalars['String']['output'];
  logLevel?: Maybe<Scalars['String']['output']>;
  logMessage?: Maybe<Scalars['String']['output']>;
  pipelineKey?: Maybe<Scalars['String']['output']>;
  pipelineName: Scalars['String']['output'];
  realm?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  timestampMillis?: Maybe<Scalars['String']['output']>;
};

export type LogSearch = {
  __typename: 'LogSearch';
  id: Scalars['String']['output'];
  logLevel?: Maybe<Scalars['String']['output']>;
  logMessage?: Maybe<Scalars['String']['output']>;
  pipelineKey?: Maybe<Scalars['String']['output']>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  timestampMillis?: Maybe<Scalars['String']['output']>;
};

export type LogsResponse = {
  __typename: 'LogsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  logs?: Maybe<Array<Maybe<Log>>>;
};

export type Message = {
  __typename: 'Message';
  elapsed_time?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  jwt_user?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  pipeline_id?: Maybe<Scalars['String']['output']>;
  pipeline_name?: Maybe<Scalars['String']['output']>;
  pipeline_source?: Maybe<Scalars['String']['output']>;
  pipeline_version?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  request_size_bytes?: Maybe<Scalars['String']['output']>;
  request_timestamp?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  response_size_bytes?: Maybe<Scalars['String']['output']>;
  response_timestamp?: Maybe<Scalars['String']['output']>;
};

export type MessageByKey = {
  __typename: 'MessageByKey';
  body?: Maybe<Scalars['String']['output']>;
  connectorId?: Maybe<Scalars['String']['output']>;
  connectorName?: Maybe<Scalars['String']['output']>;
  elapsed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  indexes?: Maybe<Scalars['JSON']['output']>;
  processorStepName?: Maybe<Scalars['String']['output']>;
  processorType?: Maybe<Scalars['String']['output']>;
  timestampEnd?: Maybe<Scalars['Float']['output']>;
  timestampStart?: Maybe<Scalars['Float']['output']>;
};

export type MessagesResponse = {
  __typename: 'MessagesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  messages?: Maybe<Array<Maybe<Message>>>;
};

export type Metrics = {
  __typename: 'Metrics';
  available?: Maybe<Scalars['String']['output']>;
  costPerEnvironment?: Maybe<Scalars['JSON']['output']>;
  costPerMetric?: Maybe<CostPerMetric>;
  currencyCode?: Maybe<CurrencyCode>;
  expirationAt?: Maybe<Scalars['String']['output']>;
  granted?: Maybe<Scalars['String']['output']>;
  monthOnMonth?: Maybe<Array<Maybe<MonthOnMonth>>>;
  overage?: Maybe<Scalars['String']['output']>;
  spent?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MetricsPrices = {
  __typename: 'MetricsPrices';
  EGRESS?: Maybe<Scalars['String']['output']>;
  EGRESS_OVERAGE?: Maybe<Scalars['String']['output']>;
  GB_SECOND?: Maybe<Scalars['String']['output']>;
  GB_SECOND_OVERAGE?: Maybe<Scalars['String']['output']>;
  NUMBER_EXECUTION?: Maybe<Scalars['String']['output']>;
  NUMBER_EXECUTION_OVERAGE?: Maybe<Scalars['String']['output']>;
};

export type MonitoringAlertConfigPagination = {
  __typename: 'MonitoringAlertConfigPagination';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type MonitoringAlertsConfigInput = {
  alertConfig: AlertConfigInput;
  alertName: Scalars['String']['input'];
  alertStatus?: InputMaybe<Scalars['Boolean']['input']>;
  notificationConfig: NotificationConfigInput;
};

export type MonthOnMonth = {
  __typename: 'MonthOnMonth';
  month?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type MoveProject = {
  __typename: 'MoveProject';
  failed?: Maybe<Array<Maybe<MoveProjectPipeline>>>;
  successful?: Maybe<Array<Maybe<MoveProjectPipeline>>>;
  warnings?: Maybe<Array<Maybe<MoveProjectWarning>>>;
};

export type MoveProjectPipeline = {
  __typename: 'MoveProjectPipeline';
  pipelineName?: Maybe<Scalars['String']['output']>;
  pipelineVersionMajor?: Maybe<Scalars['Int']['output']>;
};

export type MoveProjectWarning = {
  __typename: 'MoveProjectWarning';
  accounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pipeline?: Maybe<MoveProjectWarningPipeline>;
};

export type MoveProjectWarningPipeline = {
  __typename: 'MoveProjectWarningPipeline';
  pipelineName?: Maybe<Scalars['String']['output']>;
  pipelineVersionMajor?: Maybe<Scalars['Int']['output']>;
  pipelineVersionMinor?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename: 'Mutation';
  accountsNotification?: Maybe<Scalars['JSON']['output']>;
  activeAlertsConfig?: Maybe<Scalars['Boolean']['output']>;
  archiveCapsuleComponent?: Maybe<Scalars['Boolean']['output']>;
  archiveCollection?: Maybe<Scalars['Boolean']['output']>;
  archiveGroupCollection?: Maybe<CollectionGroup>;
  archiveLibraryComponent?: Maybe<Scalars['Boolean']['output']>;
  archiveOAuthProvider?: Maybe<Scalars['Boolean']['output']>;
  archiveProject?: Maybe<Scalars['Boolean']['output']>;
  checkConsumerName?: Maybe<Scalars['Boolean']['output']>;
  checkReplicaName?: Maybe<Scalars['Boolean']['output']>;
  createAccount?: Maybe<Scalars['Boolean']['output']>;
  createAlertsConfig?: Maybe<Scalars['Boolean']['output']>;
  createAlertsConfigV2?: Maybe<Scalars['Boolean']['output']>;
  createApiKey?: Maybe<Apikey>;
  createApiKeys?: Maybe<Scalars['Boolean']['output']>;
  createBasicAuth?: Maybe<BasicAuth>;
  createBatchRoute?: Maybe<Scalars['JSON']['output']>;
  createCapsuleCollectionGroupV2?: Maybe<CollectionGroup>;
  createCapsuleCollectionGroupV3?: Maybe<CollectionGroup>;
  createCapsuleCollectionHeaderV2?: Maybe<CollectionHeader>;
  createCapsuleCollectionV2?: Maybe<Scalars['JSON']['output']>;
  createCollectionGroup?: Maybe<CollectionGroup>;
  createCollectionHeader?: Maybe<CollectionHeader>;
  createConnection?: Maybe<Scalars['JSON']['output']>;
  createCredentials?: Maybe<Scalars['JSON']['output']>;
  createDataStreamingConfig?: Maybe<Scalars['Boolean']['output']>;
  createEvent?: Maybe<Scalars['Boolean']['output']>;
  createFallbackMessage?: Maybe<Scalars['Boolean']['output']>;
  createFeedback?: Maybe<Scalars['Boolean']['output']>;
  createGlobal?: Maybe<Scalars['Boolean']['output']>;
  createGroup?: Maybe<Group>;
  createIdPSettings?: Maybe<IdPSettingsDetailsApiResponse>;
  createNewCapsule?: Maybe<Scalars['JSON']['output']>;
  createNewLibrary?: Maybe<Scalars['JSON']['output']>;
  createOAuthProvider?: Maybe<Scalars['Boolean']['output']>;
  createOrUpdateCapsuleCollectionV2?: Maybe<Scalars['JSON']['output']>;
  createOrUpdateCapsuleV2?: Maybe<Capsule>;
  createParameterizedInstanceConfiguration?: Maybe<Scalars['JSON']['output']>;
  createParameterizedInstances?: Maybe<Scalars['JSON']['output']>;
  createProject?: Maybe<Project>;
  createRole?: Maybe<Role>;
  createRoute?: Maybe<Scalars['JSON']['output']>;
  createRouteInverse?: Maybe<Scalars['JSON']['output']>;
  createSamlGroupMapping?: Maybe<Scalars['Boolean']['output']>;
  createService?: Maybe<Scalars['Boolean']['output']>;
  createToken?: Maybe<Token>;
  createUser?: Maybe<Scalars['Boolean']['output']>;
  deleteAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteAlertsConfig?: Maybe<Scalars['Boolean']['output']>;
  deleteApiKey?: Maybe<Scalars['Boolean']['output']>;
  deleteApiKeys?: Maybe<Scalars['Boolean']['output']>;
  deleteAuthConfig?: Maybe<Scalars['Boolean']['output']>;
  deleteBasicAuth?: Maybe<Scalars['Boolean']['output']>;
  deleteCollectionHeader?: Maybe<Scalars['Boolean']['output']>;
  deleteConnection?: Maybe<Scalars['JSON']['output']>;
  deleteConsumers?: Maybe<Scalars['Boolean']['output']>;
  deleteCredentials?: Maybe<Scalars['Boolean']['output']>;
  deleteDataStreamingConfig?: Maybe<Scalars['Boolean']['output']>;
  deleteDeploy?: Maybe<Scalars['Boolean']['output']>;
  deleteEvent?: Maybe<Scalars['Boolean']['output']>;
  deleteGlobal?: Maybe<Scalars['Boolean']['output']>;
  deleteGroup?: Maybe<Scalars['Boolean']['output']>;
  deleteInflightTransaction?: Maybe<Scalars['Boolean']['output']>;
  deleteParameterizedInstances?: Maybe<Scalars['Boolean']['output']>;
  deletePipeline?: Maybe<Scalars['Boolean']['output']>;
  deleteProfile?: Maybe<Scalars['Boolean']['output']>;
  deleteRole?: Maybe<Scalars['Boolean']['output']>;
  deleteRoute?: Maybe<Scalars['JSON']['output']>;
  deleteSamlGroupMapping?: Maybe<Scalars['Boolean']['output']>;
  deleteTemplate?: Maybe<Scalars['Boolean']['output']>;
  deleteToken?: Maybe<Scalars['Boolean']['output']>;
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  deploy?: Maybe<Scalars['Boolean']['output']>;
  deployCapsuleComponent?: Maybe<CapsuleComponent>;
  deployLibraryComponent?: Maybe<LibraryComponent>;
  deployV2?: Maybe<Scalars['Boolean']['output']>;
  deploymentPlanDelete?: Maybe<Scalars['Boolean']['output']>;
  deploymentPlanExecute?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  deploymentPlanInsert?: Maybe<Scalars['Boolean']['output']>;
  deploymentPlanPromote?: Maybe<Scalars['JSON']['output']>;
  deploymentPlanUpdate?: Maybe<DeploymentPlan>;
  editApiKeys?: Maybe<Scalars['Boolean']['output']>;
  editCollectionHeader?: Maybe<CollectionHeader>;
  editConsumer?: Maybe<Scalars['Boolean']['output']>;
  editGlobal?: Maybe<Scalars['Boolean']['output']>;
  editGroup?: Maybe<Group>;
  editGroupCollection?: Maybe<CollectionGroup>;
  editGroupCollectionV2?: Maybe<CollectionGroup>;
  editProfile?: Maybe<UserProfile>;
  editProject?: Maybe<Project>;
  editRole?: Maybe<Role>;
  editSamlGroupMapping?: Maybe<Scalars['Boolean']['output']>;
  editUser?: Maybe<Scalars['Boolean']['output']>;
  executeCapsuleV2?: Maybe<Scalars['String']['output']>;
  executeMultipleTestCases?: Maybe<Scalars['String']['output']>;
  executeMultipleTestCasesV2?: Maybe<ExecuteMultipleTestCasesResponse>;
  generateAIDocumentation?: Maybe<Scalars['JSON']['output']>;
  generateCapsuleAIDocumentation?: Maybe<Scalars['JSON']['output']>;
  generateKey?: Maybe<Scalars['JSON']['output']>;
  getGroupUsers?: Maybe<Array<Maybe<UserAuth>>>;
  getTogaiToken?: Maybe<Scalars['JSON']['output']>;
  globalsNotification?: Maybe<Scalars['JSON']['output']>;
  moveCapsule?: Maybe<Scalars['JSON']['output']>;
  moveProject?: Maybe<MoveProject>;
  newPassword?: Maybe<Scalars['Boolean']['output']>;
  pipelineConfirmAlert?: Maybe<Scalars['Boolean']['output']>;
  pipelineRestore?: Maybe<Scalars['Boolean']['output']>;
  publishCapsuleV2?: Maybe<Capsule>;
  reactivateUser?: Maybe<Scalars['Boolean']['output']>;
  redeploy?: Maybe<Scalars['Boolean']['output']>;
  reexecutePipeline?: Maybe<Scalars['String']['output']>;
  relationsDelete?: Maybe<Scalars['Boolean']['output']>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  restoreGroup?: Maybe<GroupApiResponse>;
  revertDeploy?: Maybe<Scalars['JSON']['output']>;
  revertPipelineCanvasVersion?: Maybe<PipelineVersion>;
  rollbackDeploy?: Maybe<Scalars['JSON']['output']>;
  rollbackDeployDetails?: Maybe<Scalars['JSON']['output']>;
  saveConsumer?: Maybe<Scalars['Boolean']['output']>;
  saveProfile?: Maybe<Scalars['Boolean']['output']>;
  saveRelation?: Maybe<Scalars['Boolean']['output']>;
  termAcceptanceResponse?: Maybe<Scalars['JSON']['output']>;
  testCapsule?: Maybe<Scalars['String']['output']>;
  testLibrary?: Maybe<Scalars['String']['output']>;
  testPipeline?: Maybe<Scalars['String']['output']>;
  testPipelineV2?: Maybe<Scalars['String']['output']>;
  unarchiveCapsuleV2?: Maybe<Scalars['Boolean']['output']>;
  unarchiveProject?: Maybe<Scalars['Boolean']['output']>;
  unlockUser?: Maybe<Scalars['Boolean']['output']>;
  updateAlertsConfig?: Maybe<Scalars['Boolean']['output']>;
  updateAlertsConfigV2?: Maybe<Scalars['Boolean']['output']>;
  updateCapsule?: Maybe<CapsuleComponent>;
  updateConnection?: Maybe<Scalars['JSON']['output']>;
  updateDataStreamingConfig?: Maybe<Scalars['Boolean']['output']>;
  updateEnabledSupportAccess?: Maybe<Scalars['JSON']['output']>;
  updateIdPSettings?: Maybe<IdPSettingsDetailsApiResponse>;
  updateInstanceFields?: Maybe<Scalars['Boolean']['output']>;
  updateLibrary?: Maybe<LibraryComponent>;
  updateOAuthProvider?: Maybe<Scalars['Boolean']['output']>;
  updateParameterizedInstanceConfiguration?: Maybe<Scalars['JSON']['output']>;
  updatePermissionsV2User?: Maybe<Scalars['Boolean']['output']>;
  updatePipeline?: Maybe<PipelineVersion>;
  updatePipelineSensitiveFields?: Maybe<Scalars['Boolean']['output']>;
  updatePipelineSensitiveFieldsV2?: Maybe<Scalars['Boolean']['output']>;
  updatePipelineV2?: Maybe<PipelineVersion>;
  updatePipelineVersionMinor?: Maybe<Scalars['String']['output']>;
  updatePlatformParameter?: Maybe<Scalars['JSON']['output']>;
  updatePolicy?: Maybe<Scalars['JSON']['output']>;
  updateRelation?: Maybe<Scalars['Boolean']['output']>;
  updateRoute?: Maybe<Scalars['JSON']['output']>;
  updateTemplate?: Maybe<Scalars['Boolean']['output']>;
  upgradePipelineVersion?: Maybe<Scalars['ID']['output']>;
  userAssignGroup?: Maybe<UserAuth>;
};

export type MutationAccountsNotificationArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  deployments?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationActiveAlertsConfigArgs = {
  alertStatus: Scalars['Boolean']['input'];
  environment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationArchiveCapsuleComponentArgs = {
  idCapsule: Scalars['String']['input'];
  idComponent: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationArchiveCollectionArgs = {
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationArchiveGroupCollectionArgs = {
  groupId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationArchiveLibraryComponentArgs = {
  idComponent: Scalars['String']['input'];
  idLibrary: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationArchiveOAuthProviderArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationArchiveProjectArgs = {
  projectId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCheckConsumerNameArgs = {
  environment: Scalars['String']['input'];
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCheckReplicaNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateAccountArgs = {
  account?: InputMaybe<AccountInput>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAlertsConfigArgs = {
  alert?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateAlertsConfigV2Args = {
  alert?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateApiKeyArgs = {
  consumer: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateApiKeysArgs = {
  acls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  consumer: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateBasicAuthArgs = {
  basicAuth?: InputMaybe<BasicAuthInput>;
  consumer: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateBatchRouteArgs = {
  items?: InputMaybe<Scalars['JSON']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCapsuleCollectionGroupV2Args = {
  collectionId: Scalars['String']['input'];
  group?: InputMaybe<CollectionGroupInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateCapsuleCollectionGroupV3Args = {
  collectionId: Scalars['String']['input'];
  group?: InputMaybe<CollectionGroupInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateCapsuleCollectionHeaderV2Args = {
  header?: InputMaybe<CollectionHeaderInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateCapsuleCollectionV2Args = {
  colorAccent: Scalars['String']['input'];
  colorBackground: Scalars['String']['input'];
  colorDefault: Scalars['String']['input'];
  description: Scalars['String']['input'];
  headerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MutationCreateCollectionGroupArgs = {
  collectionId: Scalars['String']['input'];
  group?: InputMaybe<CollectionGroupInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateCollectionHeaderArgs = {
  header?: InputMaybe<CollectionHeaderInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateConnectionArgs = {
  connectionAlias: Scalars['String']['input'];
  connectionEnvironment?: InputMaybe<Scalars['String']['input']>;
  connectionGroup: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  realmNetworkRegion: Scalars['String']['input'];
};

export type MutationCreateCredentialsArgs = {
  credential?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateDataStreamingConfigArgs = {
  dataStreaming?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationCreateEventArgs = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateFallbackMessageArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateFeedbackArgs = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  path: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateGlobalArgs = {
  globalObject?: InputMaybe<GlobalInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateGroupArgs = {
  group?: InputMaybe<GroupInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateIdPSettingsArgs = {
  idPCertificate: Scalars['String']['input'];
  idPLoginURL: Scalars['String']['input'];
  idPName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateNewCapsuleArgs = {
  capsule: Scalars['JSON']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateNewLibraryArgs = {
  library: Scalars['JSON']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateOAuthProviderArgs = {
  data: CreateOAuthProviderFromBaseProviderInput;
  realm: Scalars['String']['input'];
};

export type MutationCreateOrUpdateCapsuleCollectionV2Args = {
  collection: Scalars['JSON']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateOrUpdateCapsuleV2Args = {
  capsule: CapsuleInput;
  collectionId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  mocks?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationCreateParameterizedInstanceConfigurationArgs = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
  replicaName: Scalars['String']['input'];
};

export type MutationCreateParameterizedInstancesArgs = {
  instanceModel?: InputMaybe<ParameterizedInstancesInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateProjectArgs = {
  project?: InputMaybe<ProjectInput>;
  realm: Scalars['String']['input'];
};

export type MutationCreateRoleArgs = {
  realm: Scalars['String']['input'];
  role?: InputMaybe<RoleInput>;
};

export type MutationCreateRouteArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  expectedSubdomain?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  realmNetworkRegion?: InputMaybe<Scalars['String']['input']>;
  targetHost?: InputMaybe<Scalars['String']['input']>;
  targetPorts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationCreateRouteInverseArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  expectedSubdomain?: InputMaybe<Scalars['String']['input']>;
  ingressHost?: InputMaybe<Scalars['String']['input']>;
  ingressPorts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ingressProtocol: Scalars['String']['input'];
  realm?: InputMaybe<Scalars['String']['input']>;
  realmNetworkRegion?: InputMaybe<Scalars['String']['input']>;
  targetProtocol: Scalars['String']['input'];
};

export type MutationCreateSamlGroupMappingArgs = {
  integrations?: InputMaybe<Array<InputMaybe<SamlGroupMappingInput>>>;
  realm: Scalars['String']['input'];
};

export type MutationCreateServiceArgs = {
  realm: Scalars['String']['input'];
  service: LibraryServiceInput;
};

export type MutationCreateTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationCreateUserArgs = {
  realm: Scalars['String']['input'];
  user?: InputMaybe<UserInput>;
};

export type MutationDeleteAccountArgs = {
  accountId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteAlertsConfigArgs = {
  environment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteApiKeyArgs = {
  apikeyId: Scalars['String']['input'];
  consumer: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteApiKeysArgs = {
  consumerId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteAuthConfigArgs = {
  authConfigId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationDeleteBasicAuthArgs = {
  consumer: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MutationDeleteCollectionHeaderArgs = {
  collectionHeaderId: Scalars['String']['input'];
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteConnectionArgs = {
  connectionId?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteConsumersArgs = {
  consumerId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteCredentialsArgs = {
  environment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteDataStreamingConfigArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteDeployArgs = {
  deployment: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteEventArgs = {
  eventId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteGlobalArgs = {
  globalId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationDeleteGroupArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteInflightTransactionArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationDeleteParameterizedInstancesArgs = {
  label: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeletePipelineArgs = {
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteProfileArgs = {
  code: Scalars['String']['input'];
  methodId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationDeleteRoleArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteRouteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteSamlGroupMappingArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeleteTemplateArgs = {
  realm: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type MutationDeleteTokenArgs = {
  realm: Scalars['String']['input'];
};

export type MutationDeleteUserArgs = {
  email: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeployArgs = {
  configuration: Scalars['JSON']['input'];
  environment: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  isPipelineEngine?: InputMaybe<Scalars['Boolean']['input']>;
  minReplicas?: InputMaybe<Scalars['Int']['input']>;
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  replicas: Scalars['Int']['input'];
};

export type MutationDeployCapsuleComponentArgs = {
  idCapsule: Scalars['String']['input'];
  idComponent: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeployLibraryComponentArgs = {
  idComponent: Scalars['String']['input'];
  idLibrary: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationDeployV2Args = {
  configuration: Scalars['JSON']['input'];
  cooldownPeriod?: InputMaybe<Scalars['Int']['input']>;
  environment: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  isPipelineEngine?: InputMaybe<Scalars['Boolean']['input']>;
  minReplicas?: InputMaybe<Scalars['Int']['input']>;
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  replicas: Scalars['Int']['input'];
};

export type MutationDeploymentPlanDeleteArgs = {
  deploymentPlanId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationDeploymentPlanExecuteArgs = {
  deploymentPlanId: Scalars['String']['input'];
  isPipelineEngine?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineDeploys?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationDeploymentPlanInsertArgs = {
  deploymentPlan?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationDeploymentPlanPromoteArgs = {
  deploymentPlanId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  isPipelineEngine?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
  sourceEnvironment: Scalars['String']['input'];
};

export type MutationDeploymentPlanUpdateArgs = {
  deploymentPlan?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationEditApiKeysArgs = {
  acls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  changeAcls?: InputMaybe<Scalars['Boolean']['input']>;
  consumer: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationEditCollectionHeaderArgs = {
  header?: InputMaybe<CollectionHeaderInput>;
  realm: Scalars['String']['input'];
};

export type MutationEditConsumerArgs = {
  acls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  consumer: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationEditGlobalArgs = {
  globalId?: InputMaybe<Scalars['String']['input']>;
  globalObject?: InputMaybe<GlobalInput>;
  realm: Scalars['String']['input'];
};

export type MutationEditGroupArgs = {
  group?: InputMaybe<GroupInput>;
  policy?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationEditGroupCollectionArgs = {
  collectionId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationEditGroupCollectionV2Args = {
  groupId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationEditProfileArgs = {
  profile?: InputMaybe<UserProfileInput>;
  realm: Scalars['String']['input'];
};

export type MutationEditProjectArgs = {
  project?: InputMaybe<ProjectInput>;
  realm: Scalars['String']['input'];
};

export type MutationEditRoleArgs = {
  realm: Scalars['String']['input'];
  role?: InputMaybe<RoleInput>;
};

export type MutationEditSamlGroupMappingArgs = {
  integration?: InputMaybe<SamlGroupMappingInput>;
  realm: Scalars['String']['input'];
};

export type MutationEditUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  user?: InputMaybe<UserInput>;
};

export type MutationExecuteCapsuleV2Args = {
  accountLabels?: InputMaybe<Scalars['JSON']['input']>;
  flowSpec: Scalars['JSON']['input'];
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  payload: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};

export type MutationExecuteMultipleTestCasesArgs = {
  environmentParameters?: InputMaybe<Array<EnvironmentParameterInput>>;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
  realmName: Scalars['String']['input'];
  testCases: Array<TestCaseInput>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationExecuteMultipleTestCasesV2Args = {
  environmentParameters?: InputMaybe<Array<EnvironmentParameterInput>>;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
  realmName: Scalars['String']['input'];
  testCases: Array<TestCaseInput>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationGenerateAiDocumentationArgs = {
  lang: Scalars['String']['input'];
  pipeline: PipelineAiDocumentationInput;
  realm: Scalars['String']['input'];
};

export type MutationGenerateCapsuleAiDocumentationArgs = {
  configExample: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  flowSpec: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  jsonSchema: Array<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  outSpec: Scalars['JSON']['input'];
  realm: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MutationGenerateKeyArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationGetGroupUsersArgs = {
  realm: Scalars['String']['input'];
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationGetTogaiTokenArgs = {
  realmName: Scalars['String']['input'];
};

export type MutationGlobalsNotificationArgs = {
  deployments?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  globalId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationMoveCapsuleArgs = {
  capsuleGroupId: Scalars['String']['input'];
  capsuleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  realm: Scalars['String']['input'];
};

export type MutationMoveProjectArgs = {
  pipelines?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  projectId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationNewPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationPipelineConfirmAlertArgs = {
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationPipelineRestoreArgs = {
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationPublishCapsuleV2Args = {
  capsuleId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationReactivateUserArgs = {
  email: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationRedeployArgs = {
  configuration: Scalars['JSON']['input'];
  environment: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  isPipelineEngine?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  replicas: Scalars['Int']['input'];
};

export type MutationReexecutePipelineArgs = {
  environment: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
  pipeName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type MutationRelationsDeleteArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationRestoreGroupArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  realm: Scalars['String']['input'];
};

export type MutationRevertDeployArgs = {
  deployHistoryId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationRevertPipelineCanvasVersionArgs = {
  pipelineId: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};

export type MutationRollbackDeployArgs = {
  deployment: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  pipelineMajorVersion: Scalars['String']['input'];
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationRollbackDeployDetailsArgs = {
  deployment: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  pipelineMajorVersion: Scalars['String']['input'];
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationSaveConsumerArgs = {
  acls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  consumer: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationSaveProfileArgs = {
  code: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type MutationSaveRelationArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  newRelation?: InputMaybe<RelationshipInput>;
  realm: Scalars['String']['input'];
};

export type MutationTermAcceptanceResponseArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export type MutationTestCapsuleArgs = {
  accountLabels?: InputMaybe<Scalars['JSON']['input']>;
  canvas: CanvasInput;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  payload: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};

export type MutationTestLibraryArgs = {
  accountLabels?: InputMaybe<Scalars['JSON']['input']>;
  canvas: CanvasInput;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  payload: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};

export type MutationTestPipelineArgs = {
  canvas: CanvasInput;
  parameterizedReplica?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};

export type MutationTestPipelineV2Args = {
  flowSpec: Scalars['JSON']['input'];
  parameterizedReplica?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};

export type MutationUnarchiveCapsuleV2Args = {
  capsuleCollectionId: Scalars['String']['input'];
  capsuleId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUnarchiveProjectArgs = {
  projectId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUnlockUserArgs = {
  email: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUpdateAlertsConfigArgs = {
  alert?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUpdateAlertsConfigV2Args = {
  alert?: InputMaybe<Scalars['JSON']['input']>;
  environment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUpdateCapsuleArgs = {
  capsule: CapsuleComponentInput;
  realm: Scalars['String']['input'];
};

export type MutationUpdateConnectionArgs = {
  connectionAlias: Scalars['String']['input'];
  connectionEnvironment?: InputMaybe<Scalars['String']['input']>;
  connectionGroup: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUpdateDataStreamingConfigArgs = {
  dataStreaming?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationUpdateEnabledSupportAccessArgs = {
  assignedDays: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  realm: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type MutationUpdateIdPSettingsArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  idPLoginURL?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationUpdateInstanceFieldsArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  realm: Scalars['String']['input'];
  replicaName?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLibraryArgs = {
  library: LibraryComponentInput;
  realm: Scalars['String']['input'];
};

export type MutationUpdateOAuthProviderArgs = {
  data: UpdateOAuthProviderFromBaseProviderInput;
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUpdateParameterizedInstanceConfigurationArgs = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  realm: Scalars['String']['input'];
  replicaName: Scalars['String']['input'];
};

export type MutationUpdatePermissionsV2UserArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUpdatePipelineArgs = {
  pipeline: PipelineVersionInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  trackingId: Scalars['String']['input'];
};

export type MutationUpdatePipelineSensitiveFieldsArgs = {
  pipelineId: Scalars['String']['input'];
  realm?: InputMaybe<Scalars['String']['input']>;
  sensitiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationUpdatePipelineSensitiveFieldsV2Args = {
  pipelineId: Scalars['String']['input'];
  realm?: InputMaybe<Scalars['String']['input']>;
  sensitiveFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationUpdatePipelineV2Args = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  mocks?: InputMaybe<Scalars['JSON']['input']>;
  pipeline: PipelineVersionInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  testCases?: InputMaybe<Scalars['JSON']['input']>;
  trackingId: Scalars['String']['input'];
};

export type MutationUpdatePipelineVersionMinorArgs = {
  pipelineId: Scalars['String']['input'];
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  versionMajor: Scalars['Int']['input'];
};

export type MutationUpdatePlatformParameterArgs = {
  especific?: InputMaybe<Scalars['Boolean']['input']>;
  parameter: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationUpdatePolicyArgs = {
  environmentsParameters?: InputMaybe<Scalars['JSON']['input']>;
  policyName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type MutationUpdateRelationArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  newRelation?: InputMaybe<RelationshipInput>;
  realm: Scalars['String']['input'];
};

export type MutationUpdateRouteArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  expectedSubdomain?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  realmNetworkRegion?: InputMaybe<Scalars['String']['input']>;
  targetHost?: InputMaybe<Scalars['String']['input']>;
  targetPorts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationUpdateTemplateArgs = {
  realm: Scalars['String']['input'];
  template: TemplatesInput;
};

export type MutationUpgradePipelineVersionArgs = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type MutationUserAssignGroupArgs = {
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type Node = {
  __typename: 'Node';
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NodeInput = {
  data: Scalars['String']['input'];
  id: Scalars['String']['input'];
  left?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type NotificationChannelParamsInput = {
  emailContent?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailTo: Array<InputMaybe<Scalars['String']['input']>>;
};

export type NotificationChannels = {
  __typename: 'NotificationChannels';
  notificationChannelParams: NotificationChannelsParams;
  notificationChannelType: Scalars['String']['output'];
};

export type NotificationChannelsInput = {
  notificationChannelParams: NotificationChannelParamsInput;
  notificationChannelType: Scalars['String']['input'];
};

export type NotificationChannelsParams = EmailParams | TelegramParams;

export type NotificationConfig = {
  __typename: 'NotificationConfig';
  notificationChannels: Array<Maybe<NotificationChannels>>;
};

export type NotificationConfigInput = {
  notificationChannels: Array<InputMaybe<NotificationChannelsInput>>;
};

export type NumberOfExecution = {
  __typename: 'NumberOfExecution';
  costCurrency?: Maybe<Scalars['String']['output']>;
  spentMetric?: Maybe<Scalars['String']['output']>;
};

export type OAuthProvider = {
  __typename: 'OAuthProvider';
  authURL?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  delimiter?: Maybe<Scalars['String']['output']>;
  grantRequestBody?: Maybe<Scalars['JSON']['output']>;
  grantURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCertificate?: Maybe<Scalars['Boolean']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  realm: Scalars['String']['output'];
  redirect_uri?: Maybe<Scalars['String']['output']>;
  refreshURL?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type ParameterizedInstances = {
  __typename: 'ParameterizedInstances';
  description?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  instanceEnvironmentFieldValue?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ParameterizedInstancesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ParameterizedInstancesPagination = {
  __typename: 'ParameterizedInstancesPagination';
  content?: Maybe<Array<Maybe<ParameterizedInstances>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Permission = {
  __typename: 'Permission';
  description?: Maybe<Scalars['String']['output']>;
  environmentCapable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
};

export type Pipeline = {
  __typename: 'Pipeline';
  alert?: Maybe<Scalars['JSON']['output']>;
  canvasVersion: Scalars['Int']['output'];
  deployments?: Maybe<Array<Deployment>>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  hasAlert?: Maybe<Scalars['Boolean']['output']>;
  iconTrigger?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latestVersionMinor: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  parameterizedReplica?: Maybe<Scalars['String']['output']>;
  thumbnailName?: Maybe<Scalars['String']['output']>;
  thumbnailURL?: Maybe<Scalars['String']['output']>;
  triggerSpec?: Maybe<Scalars['JSON']['output']>;
  versionMajor: Scalars['Int']['output'];
  versionMinor: Scalars['Int']['output'];
  versions?: Maybe<Array<PipelineVersion>>;
};

export type PipelineAiDocumentationInput = {
  flowSpec?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  triggerSpec?: InputMaybe<Scalars['JSON']['input']>;
  versionMajor?: InputMaybe<Scalars['Int']['input']>;
  versionMinor?: InputMaybe<Scalars['Int']['input']>;
};

export type PipelineAndConsumer = {
  __typename: 'PipelineAndConsumer';
  customId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type PipelineMajorVersion = {
  __typename: 'PipelineMajorVersion';
  majorVersion?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PipelinePageable = {
  __typename: 'PipelinePageable';
  content?: Maybe<Array<Maybe<Pipeline>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PipelinePagination = {
  __typename: 'PipelinePagination';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PipelineStats = {
  __typename: 'PipelineStats';
  pipelineName?: Maybe<Scalars['String']['output']>;
  pipelineVersionStats?: Maybe<Array<Maybe<PipelineVersionStats>>>;
};

export type PipelineVersion = {
  __typename: 'PipelineVersion';
  alert?: Maybe<Scalars['JSON']['output']>;
  canvas?: Maybe<Canvas>;
  canvasVersion?: Maybe<Scalars['Int']['output']>;
  componentsCount?: Maybe<Scalars['Int']['output']>;
  connectedOnFlowComponentsCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Float']['output']>;
  deploy?: Maybe<Scalars['Boolean']['output']>;
  deployments?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  disconnectedFlowSpecs?: Maybe<Scalars['JSON']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  flowSpec?: Maybe<Scalars['JSON']['output']>;
  folderId?: Maybe<Scalars['String']['output']>;
  hasAlert?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inSpec?: Maybe<Scalars['JSON']['output']>;
  isUsingApiTrigger?: Maybe<Scalars['Boolean']['output']>;
  isUsingMcpServerTrigger?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['Float']['output']>;
  mcpServerTriggerTools?: Maybe<Scalars['JSON']['output']>;
  mocks?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outSpec?: Maybe<Scalars['JSON']['output']>;
  parameterizedReplica?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['JSON']['output']>;
  restApiTriggerRoutes?: Maybe<Scalars['JSON']['output']>;
  stepsDocumentations?: Maybe<Scalars['JSON']['output']>;
  suggestedComponentsIds?: Maybe<Scalars['JSON']['output']>;
  testCases?: Maybe<Scalars['JSON']['output']>;
  thumbnailName?: Maybe<Scalars['String']['output']>;
  triggerCategory?: Maybe<Scalars['String']['output']>;
  triggerSpec?: Maybe<Scalars['JSON']['output']>;
  usedComponents?: Maybe<Scalars['JSON']['output']>;
  versionMajor?: Maybe<Scalars['Int']['output']>;
  versionMinor?: Maybe<Scalars['Int']['output']>;
};

export type PipelineVersionInput = {
  alert?: InputMaybe<Scalars['JSON']['input']>;
  canvas?: InputMaybe<CanvasInput>;
  componentsCount?: InputMaybe<Scalars['Int']['input']>;
  connectedOnFlowComponentsCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disconnectedFlowSpecs?: InputMaybe<Scalars['JSON']['input']>;
  draft: Scalars['Boolean']['input'];
  flowSpec?: InputMaybe<Scalars['JSON']['input']>;
  hasAlert?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  isApiFromPipelines?: InputMaybe<Scalars['Boolean']['input']>;
  isMcpServerFromPipelines?: InputMaybe<Scalars['Boolean']['input']>;
  isUsingApiTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  isUsingMcpServerTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  mcpServerTriggerTools?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  parameterizedReplica?: InputMaybe<Scalars['String']['input']>;
  previewName?: InputMaybe<Scalars['String']['input']>;
  restApiTriggerRoutes?: InputMaybe<Scalars['JSON']['input']>;
  stepsDocumentations?: InputMaybe<Scalars['JSON']['input']>;
  suggestedComponentsIds?: InputMaybe<Scalars['JSON']['input']>;
  thumbnailName?: InputMaybe<Scalars['String']['input']>;
  triggerCategory?: InputMaybe<Scalars['String']['input']>;
  triggerSpec?: InputMaybe<Scalars['JSON']['input']>;
  usedComponents?: InputMaybe<Scalars['JSON']['input']>;
  versionMajor: Scalars['Int']['input'];
  versionMinor: Scalars['Int']['input'];
};

export type PipelineVersionStats = {
  __typename: 'PipelineVersionStats';
  dateHistogramStats?: Maybe<Array<Maybe<DateHistogramStats>>>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<DateHistogramStats>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PipelineWithProjectAndEnvironment = {
  __typename: 'PipelineWithProjectAndEnvironment';
  environments: Array<Maybe<Environment>>;
  pipeline?: Maybe<Pipeline>;
  project?: Maybe<Project>;
};

export type PipelineWithProjectAndEnvironmentPageable = {
  __typename: 'PipelineWithProjectAndEnvironmentPageable';
  content?: Maybe<Array<Maybe<PipelineWithProjectAndEnvironment>>>;
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PlanLicenseStatus = {
  __typename: 'PlanLicenseStatus';
  licenseModel?: Maybe<Scalars['String']['output']>;
  pipelineSubscriptionAndRtu?: Maybe<Scalars['JSON']['output']>;
  totalAvailableLicenses?: Maybe<Scalars['Int']['output']>;
  totalLicensesInUse?: Maybe<Scalars['Int']['output']>;
  totalLicensesUsedByPlan?: Maybe<Scalars['Int']['output']>;
  totalRealmLicenses?: Maybe<Scalars['Int']['output']>;
};

export type Policy = {
  __typename: 'Policy';
  bindings?: Maybe<Array<Maybe<Binding>>>;
  custom?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Profile = {
  __typename: 'Profile';
  methodId?: Maybe<Scalars['String']['output']>;
  secret: Scalars['String']['output'];
  secretBase32Encoded: Scalars['String']['output'];
  twoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type Project = {
  __typename: 'Project';
  allowAllUsers?: Maybe<Scalars['Boolean']['output']>;
  allowedGroups?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  allowedUsers?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  amountOfPipelines?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailsOfAllowedGroups?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  detailsOfAllowedUsers?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['String']['output']>;
};

export type ProjectInput = {
  allowAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  allowedGroups?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  allowedUsers?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename: 'Query';
  accountById?: Maybe<Account>;
  accountTypes?: Maybe<Array<Maybe<AccountType>>>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  accountsAssociatedDeployments?: Maybe<DeploymentPageable>;
  accountsAssociatedPipelines?: Maybe<PipelineWithProjectAndEnvironmentPageable>;
  accountsPaginated?: Maybe<AccountPageable>;
  acl?: Maybe<Acls>;
  acls?: Maybe<Acl>;
  aclsDigibeectl?: Maybe<Acl>;
  apiKeys?: Maybe<Array<Maybe<ApiKeys>>>;
  audit?: Maybe<AuditPagination>;
  authConfig?: Maybe<Array<Maybe<AuthConfig>>>;
  canCapsuleMove?: Maybe<Scalars['JSON']['output']>;
  capsuleCatalogs?: Maybe<Array<CapsuleService>>;
  capsuleCollectionGroupsV2?: Maybe<Array<Maybe<CollectionGroup>>>;
  capsuleCollectionGroupsV3?: Maybe<Array<Maybe<CollectionGroup>>>;
  capsuleCollectionHeaderV2?: Maybe<Array<Maybe<CollectionHeader>>>;
  capsuleCollectionHeaderV3?: Maybe<Array<Maybe<CollectionHeader>>>;
  capsuleCollections?: Maybe<CapsulePagination>;
  capsuleCollectionsV2?: Maybe<CapsulePagination>;
  capsuleComponents?: Maybe<CapsuleComponent>;
  capsuleV2?: Maybe<Capsule>;
  capsulesConsumers?: Maybe<Array<Maybe<CapsuleCatalog>>>;
  capsulesPaginations?: Maybe<CapsulePagination>;
  checkLicense?: Maybe<Validate>;
  checkUserPipelineAccess?: Maybe<Scalars['Boolean']['output']>;
  collectionGroups?: Maybe<Array<Maybe<CollectionGroup>>>;
  collectionGroupsPagination?: Maybe<CollectionGroupsPagination>;
  collectionGroupsPaginationV2?: Maybe<CollectionGroupsPagination>;
  collectionHeader?: Maybe<Array<Maybe<CollectionHeader>>>;
  components?: Maybe<Array<Component>>;
  componentsByCapsule?: Maybe<CapsuleComponentPagination>;
  componentsByLibrary?: Maybe<LibraryComponentPagination>;
  configurations?: Maybe<Array<Maybe<Configuration>>>;
  connections?: Maybe<Array<Maybe<Connection>>>;
  consumerApiKeys?: Maybe<Array<Maybe<ConsumerApikeys>>>;
  consumers?: Maybe<Array<Maybe<Consumer>>>;
  consumptionBasedMetrics?: Maybe<ConsumptionBasedMetrics>;
  consumptionProjects?: Maybe<Array<Maybe<ConsumptionByProject>>>;
  countActiveIntegrations?: Maybe<Scalars['Int']['output']>;
  countedLogs?: Maybe<Scalars['JSON']['output']>;
  deployHistory?: Maybe<DeployHistoryPageable>;
  deployHistoryDistinct?: Maybe<DeployHistoryDistinctPageable>;
  deployment?: Maybe<Deployment>;
  deploymentByNameAndVersionMajor?: Maybe<Deployment>;
  deploymentPipelineEngineConfiguration?: Maybe<Scalars['Boolean']['output']>;
  deploymentPlanLicense?: Maybe<PlanLicenseStatus>;
  deploymentPlanList?: Maybe<DeploymentPlanPageable>;
  deploymentPlanPromoteInfo?: Maybe<Array<Maybe<DeploymentPlanItem>>>;
  deployments?: Maybe<Array<Maybe<Deployment>>>;
  deploymentsPaginated?: Maybe<DeploymentPageable>;
  downloadCreditsInformation?: Maybe<Scalars['String']['output']>;
  enabledSupportAccess?: Maybe<Scalars['JSON']['output']>;
  endpoints?: Maybe<Array<Maybe<Endpoint>>>;
  environments?: Maybe<Array<Maybe<Environment>>>;
  events?: Maybe<Array<Maybe<Event>>>;
  getAlertsConfig?: Maybe<Scalars['JSON']['output']>;
  getAlertsConfigById?: Maybe<Scalars['JSON']['output']>;
  getAlertsConfigByName?: Maybe<Scalars['JSON']['output']>;
  getAlertsConfigByNameV2?: Maybe<Scalars['JSON']['output']>;
  getAlertsConfigV2?: Maybe<Scalars['JSON']['output']>;
  getCredentials?: Maybe<Scalars['JSON']['output']>;
  getCredentialsUrl?: Maybe<Scalars['JSON']['output']>;
  getDataStreamingConfig?: Maybe<Scalars['JSON']['output']>;
  getFirstPolicyGroup?: Maybe<Policy>;
  getLostPermissions?: Maybe<Scalars['JSON']['output']>;
  getMappings?: Maybe<Scalars['JSON']['output']>;
  getMetrics?: Maybe<Scalars['JSON']['output']>;
  getMetricsV2?: Maybe<Scalars['JSON']['output']>;
  getPermissionsUser?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getPipelinesDeployments?: Maybe<Scalars['JSON']['output']>;
  getProfile?: Maybe<UserProfile>;
  getProject?: Maybe<Project>;
  getRealm?: Maybe<Realm>;
  getTunnels?: Maybe<Scalars['JSON']['output']>;
  getUser?: Maybe<UserAuth>;
  globals?: Maybe<Array<Maybe<Global>>>;
  globalsAssociatedDeployments?: Maybe<DeploymentPageable>;
  globalsAssociatedPipelines?: Maybe<PipelineWithProjectAndEnvironmentPageable>;
  globalsPaginated?: Maybe<GlobalPageable>;
  groupCapsules?: Maybe<CapsuleComponentPagination>;
  groups?: Maybe<Groups>;
  helpHubGetPageById?: Maybe<Scalars['JSON']['output']>;
  helpHubGetPages?: Maybe<Scalars['JSON']['output']>;
  historyPipeline?: Maybe<Scalars['JSON']['output']>;
  idPSettings?: Maybe<IdPSettingsDataApiResponse>;
  idPSettingsDetails?: Maybe<IdPSettingsDetailsApiResponse>;
  inflightTransactions?: Maybe<InflightTransactions>;
  intellisenseCompletions?: Maybe<Array<Maybe<IntelliSenseCompletion>>>;
  intercom?: Maybe<Scalars['String']['output']>;
  isCapsuleNameValid?: Maybe<Scalars['Boolean']['output']>;
  libraries?: Maybe<Array<Maybe<LibraryCatalog>>>;
  librariesConsumers?: Maybe<Array<Maybe<LibraryCatalog>>>;
  librariesPaginations?: Maybe<LibraryPagination>;
  libraryCatalogs?: Maybe<Array<LibraryService>>;
  libraryComponents?: Maybe<LibraryComponent>;
  licenseStatus?: Maybe<LicenseStatus>;
  limitOfUse?: Maybe<Scalars['JSON']['output']>;
  limitOfUseDetail?: Maybe<Scalars['JSON']['output']>;
  listPipelines?: Maybe<PipelinePagination>;
  logSearch?: Maybe<LogSearch>;
  logs?: Maybe<Array<Maybe<Log>>>;
  logsSearch?: Maybe<LogsResponse>;
  messages?: Maybe<MessagesResponse>;
  messagesByKey?: Maybe<Array<Maybe<MessageByKey>>>;
  oauthProvider?: Maybe<OAuthProvider>;
  oauthProviders?: Maybe<Array<Maybe<OAuthProvider>>>;
  onSearchCapsule?: Maybe<Scalars['JSON']['output']>;
  parameterizedInstance?: Maybe<ParameterizedInstances>;
  parameterizedInstances?: Maybe<ParameterizedInstancesPagination>;
  permissions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  pipeline?: Maybe<PipelineVersion>;
  pipelineHistory?: Maybe<Array<Maybe<PipelineVersion>>>;
  pipelineInDeploy?: Maybe<Scalars['Boolean']['output']>;
  pipelineOnDeployById?: Maybe<PipelineVersion>;
  pipelineV2?: Maybe<PipelineVersion>;
  pipelineVersions?: Maybe<Array<Maybe<PipelineVersion>>>;
  pipelines?: Maybe<Array<Pipeline>>;
  pipelinesAndConsumer?: Maybe<Array<Maybe<PipelineAndConsumer>>>;
  pipelinesUsage?: Maybe<Scalars['JSON']['output']>;
  platformParameters?: Maybe<Scalars['JSON']['output']>;
  policies?: Maybe<Scalars['JSON']['output']>;
  policiesCompliance?: Maybe<Scalars['JSON']['output']>;
  policiesPipelinesIssues?: Maybe<Scalars['JSON']['output']>;
  policy?: Maybe<Scalars['JSON']['output']>;
  profile?: Maybe<Profile>;
  projectByPipeline?: Maybe<Project>;
  projectSizeForecast?: Maybe<Scalars['JSON']['output']>;
  proposalUpsell?: Maybe<Scalars['JSON']['output']>;
  realmContacts?: Maybe<Scalars['JSON']['output']>;
  realms?: Maybe<Array<Realm>>;
  relations?: Maybe<Array<Maybe<Relationship>>>;
  relationsInstance?: Maybe<RelationshipInstance>;
  replicaInstance?: Maybe<Array<Maybe<ReplicaInstance>>>;
  replicas?: Maybe<Array<Maybe<Replica>>>;
  retention?: Maybe<Retention>;
  roles?: Maybe<RolePagination>;
  routes?: Maybe<RoutesResponse>;
  salesforceServiceDiscovery?: Maybe<Scalars['JSON']['output']>;
  samlGroupMapping?: Maybe<SamlGroupMappings>;
  samlSchemes?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  scopes?: Maybe<Array<Maybe<Scope>>>;
  searchPipelines?: Maybe<PipelinePagination>;
  searchPipelinesWithStatus?: Maybe<PipelinePagination>;
  searchUnifiedCatalog?: Maybe<CatalogPageable>;
  searchUsers?: Maybe<UserAuthPagination>;
  sensitiveFields?: Maybe<Configuration>;
  services?: Maybe<Scalars['JSON']['output']>;
  servicesLibrary?: Maybe<Array<Maybe<LibraryService>>>;
  stats?: Maybe<Stats>;
  templates?: Maybe<Array<Maybe<Templates>>>;
  termAcceptanceLatest?: Maybe<TermAcceptance>;
  triggers?: Maybe<Array<Trigger>>;
  unifiedCatalog?: Maybe<CatalogRootQuery>;
  users?: Maybe<Array<Maybe<User>>>;
  validateBasicName?: Maybe<Scalars['Boolean']['output']>;
  validateCapsuleName?: Maybe<Scalars['Boolean']['output']>;
  validateCollectionName?: Maybe<Scalars['Boolean']['output']>;
  validateCollectionNameV2?: Maybe<Scalars['Boolean']['output']>;
  validateGlobalName?: Maybe<ValidateGlobalName>;
  validateGroupName?: Maybe<Scalars['Boolean']['output']>;
  validateLibraryCatalogName?: Maybe<Scalars['Boolean']['output']>;
  validateLibraryName?: Maybe<Scalars['Boolean']['output']>;
  validatePipeline?: Maybe<Scalars['JSON']['output']>;
  validatePipelineName?: Maybe<Scalars['Boolean']['output']>;
  validateProjectName?: Maybe<Scalars['Boolean']['output']>;
  validateRoleName?: Maybe<Scalars['Boolean']['output']>;
  validateTemplateName?: Maybe<Scalars['Boolean']['output']>;
  validateUserEmail?: Maybe<Scalars['JSON']['output']>;
  versionDeployedInAllEnvironments?: Maybe<Scalars['JSON']['output']>;
  versionMinor?: Maybe<Array<Maybe<PipelineVersion>>>;
};

export type QueryAccountByIdArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryAccountTypesArgs = {
  realm: Scalars['String']['input'];
};

export type QueryAccountsArgs = {
  accountTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAccountsAssociatedDeploymentsArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryAccountsAssociatedPipelinesArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryAccountsPaginatedArgs = {
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  hasCloseToExpired?: InputMaybe<Scalars['Boolean']['input']>;
  hasExpired?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryAclArgs = {
  realm: Scalars['String']['input'];
};

export type QueryAclsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryAclsDigibeectlArgs = {
  realm: Scalars['String']['input'];
};

export type QueryApiKeysArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAuditArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAuthConfigArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryCanCapsuleMoveArgs = {
  capsuleId: Scalars['String']['input'];
  destinationGroupId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryCapsuleCatalogsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryCapsuleCollectionGroupsV2Args = {
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryCapsuleCollectionGroupsV3Args = {
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryCapsuleCollectionHeaderV2Args = {
  realm: Scalars['String']['input'];
};

export type QueryCapsuleCollectionHeaderV3Args = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryCapsuleCollectionsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryCapsuleCollectionsV2Args = {
  realm: Scalars['String']['input'];
};

export type QueryCapsuleComponentsArgs = {
  componentId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryCapsuleV2Args = {
  capsuleId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryCapsulesConsumersArgs = {
  realm: Scalars['String']['input'];
};

export type QueryCapsulesPaginationsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryCheckLicenseArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  replicas?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckUserPipelineAccessArgs = {
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryCollectionGroupsArgs = {
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryCollectionGroupsPaginationArgs = {
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryCollectionGroupsPaginationV2Args = {
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryCollectionHeaderArgs = {
  realm: Scalars['String']['input'];
};

export type QueryComponentsArgs = {
  betaShapes?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryComponentsByCapsuleArgs = {
  capsuleId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryComponentsByLibraryArgs = {
  libraryId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryConfigurationsArgs = {
  environment: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryConnectionsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryConsumerApiKeysArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsumersArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsumptionBasedMetricsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryConsumptionProjectsArgs = {
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  realm: Scalars['String']['input'];
};

export type QueryCountActiveIntegrationsArgs = {
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCountedLogsArgs = {
  environment: Scalars['String']['input'];
  pipelineKey: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryDeployHistoryArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pipelineMajorVersion?: InputMaybe<Scalars['String']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDeployHistoryDistinctArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryDeploymentByNameAndVersionMajorArgs = {
  environment: Scalars['String']['input'];
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  versionMajor: Scalars['Int']['input'];
};

export type QueryDeploymentPipelineEngineConfigurationArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryDeploymentPlanLicenseArgs = {
  deploymentPlanId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryDeploymentPlanListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryDeploymentPlanPromoteInfoArgs = {
  deploymentPlanId: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  isPipelineEngine?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
  sourceEnvironment: Scalars['String']['input'];
};

export type QueryDeploymentsArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryDeploymentsPaginatedArgs = {
  environment: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  triggers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDownloadCreditsInformationArgs = {
  realm: Scalars['String']['input'];
};

export type QueryEnabledSupportAccessArgs = {
  realm: Scalars['String']['input'];
};

export type QueryEndpointsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryEnvironmentsArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventsArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAlertsConfigArgs = {
  environment: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetAlertsConfigByIdArgs = {
  environment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetAlertsConfigByNameArgs = {
  alertName: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetAlertsConfigByNameV2Args = {
  alertName: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetAlertsConfigV2Args = {
  channel?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  metric?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  vpn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetCredentialsArgs = {
  environment: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetCredentialsUrlArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetDataStreamingConfigArgs = {
  realm: Scalars['String']['input'];
};

export type QueryGetFirstPolicyGroupArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetLostPermissionsArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetMappingsArgs = {
  order?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetMetricsArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetMetricsV2Args = {
  realm: Scalars['String']['input'];
  vpn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetPermissionsUserArgs = {
  groupedByEnv?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryGetPipelinesDeploymentsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryGetProfileArgs = {
  realm: Scalars['String']['input'];
};

export type QueryGetProjectArgs = {
  populate?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryGetRealmArgs = {
  realm: Scalars['String']['input'];
};

export type QueryGetTunnelsArgs = {
  order?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetUserArgs = {
  id: Scalars['String']['input'];
  includeGroups?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryGlobalsArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGlobalsAssociatedDeploymentsArgs = {
  globalId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryGlobalsAssociatedPipelinesArgs = {
  globalId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryGlobalsPaginatedArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryGroupCapsulesArgs = {
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGroupsArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryHelpHubGetPageByIdArgs = {
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type QueryHelpHubGetPagesArgs = {
  lang: Scalars['String']['input'];
};

export type QueryHistoryPipelineArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  versionMajor: Scalars['String']['input'];
};

export type QueryIdPSettingsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  idPName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryIdPSettingsDetailsArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryInflightTransactionsArgs = {
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryIntellisenseCompletionsArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIsCapsuleNameValidArgs = {
  capsuleName: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryLibrariesArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLibrariesConsumersArgs = {
  realm: Scalars['String']['input'];
};

export type QueryLibrariesPaginationsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryLibraryCatalogsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryLibraryComponentsArgs = {
  componentId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryLicenseStatusArgs = {
  environment: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicas: Scalars['Int']['input'];
  size: Scalars['String']['input'];
};

export type QueryLimitOfUseArgs = {
  environment: Scalars['String']['input'];
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  pipeline?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLimitOfUseDetailArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type QueryListPipelinesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryLogSearchArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryLogsArgs = {
  env?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  logIdAfter?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLogsSearchArgs = {
  afterDate?: InputMaybe<Scalars['String']['input']>;
  afterId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  logMessage?: InputMaybe<Scalars['String']['input']>;
  logType?: InputMaybe<Scalars['String']['input']>;
  pipelineKey?: InputMaybe<Scalars['String']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  pipelineVersion?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMessagesArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  jwtHash?: InputMaybe<Scalars['String']['input']>;
  jwtUser?: InputMaybe<Scalars['String']['input']>;
  lastValue?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  payloadSearch?: InputMaybe<Scalars['String']['input']>;
  pipelineKey?: InputMaybe<Scalars['String']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  pipelineVersion?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  searchAfterId?: InputMaybe<Scalars['String']['input']>;
  searchAfterTimestamp?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMessagesByKeyArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryOauthProviderArgs = {
  id: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryOauthProvidersArgs = {
  realm: Scalars['String']['input'];
};

export type QueryOnSearchCapsuleArgs = {
  capsuleGroupId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryParameterizedInstanceArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryParameterizedInstancesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPermissionsArgs = {
  environmentCapable?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryPipelineArgs = {
  id: Scalars['ID']['input'];
  realm: Scalars['String']['input'];
};

export type QueryPipelineHistoryArgs = {
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  versionMajor: Scalars['String']['input'];
};

export type QueryPipelineInDeployArgs = {
  environment: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPipelineOnDeployByIdArgs = {
  id: Scalars['ID']['input'];
  realm: Scalars['String']['input'];
};

export type QueryPipelineV2Args = {
  id: Scalars['ID']['input'];
  realm: Scalars['String']['input'];
};

export type QueryPipelineVersionsArgs = {
  environment: Scalars['String']['input'];
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  versionMajor: Scalars['String']['input'];
};

export type QueryPipelinesArgs = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  onlyDeployed?: InputMaybe<Scalars['Boolean']['input']>;
  payloadFull?: InputMaybe<Scalars['Boolean']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPipelinesAndConsumerArgs = {
  consumerId?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryPipelinesUsageArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryPlatformParametersArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryPoliciesArgs = {
  realm: Scalars['String']['input'];
};

export type QueryPoliciesComplianceArgs = {
  realm: Scalars['String']['input'];
};

export type QueryPoliciesPipelinesIssuesArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryPolicyArgs = {
  policyName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryProfileArgs = {
  realm: Scalars['String']['input'];
};

export type QueryProjectByPipelineArgs = {
  pipelineMajorVersion: Scalars['Int']['input'];
  pipelineName: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryProjectSizeForecastArgs = {
  realm: Scalars['String']['input'];
};

export type QueryProposalUpsellArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryRealmContactsArgs = {
  realm: Scalars['String']['input'];
};

export type QueryRelationsArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryRelationsInstanceArgs = {
  environment: Scalars['String']['input'];
  field?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReplicaInstanceArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  replicaName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReplicasArgs = {
  realm: Scalars['String']['input'];
};

export type QueryRetentionArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryRolesArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryRoutesArgs = {
  realm: Scalars['String']['input'];
};

export type QuerySalesforceServiceDiscoveryArgs = {
  apiVersion?: InputMaybe<Scalars['String']['input']>;
  authenticationFlow: Scalars['String']['input'];
  objectName?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  operationAccount: Scalars['String']['input'];
  parameterizedReplica?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  replicaInstanceName?: InputMaybe<Scalars['String']['input']>;
  salesforceAccount: Scalars['String']['input'];
  salesforceUrl: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySamlGroupMappingArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QuerySamlSchemesArgs = {
  realm: Scalars['String']['input'];
};

export type QueryScopesArgs = {
  realm: Scalars['String']['input'];
};

export type QuerySearchPipelinesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QuerySearchPipelinesWithStatusArgs = {
  environment: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
  status: Scalars['String']['input'];
};

export type QuerySearchUnifiedCatalogArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QuerySearchUsersArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QuerySensitiveFieldsArgs = {
  id: Scalars['ID']['input'];
  realm: Scalars['String']['input'];
};

export type QueryServicesArgs = {
  search?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryServicesLibraryArgs = {
  realm: Scalars['String']['input'];
};

export type QueryStatsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  percentile?: InputMaybe<Scalars['String']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryTemplatesArgs = {
  realm: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTermAcceptanceLatestArgs = {
  realm: Scalars['String']['input'];
  termType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTriggersArgs = {
  realm: Scalars['String']['input'];
};

export type QueryUnifiedCatalogArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  realm?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryValidateBasicNameArgs = {
  environment: Scalars['String']['input'];
  realm: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type QueryValidateCapsuleNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateCollectionNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateCollectionNameV2Args = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateGlobalNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateGroupNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateLibraryCatalogNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateLibraryNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidatePipelineArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  environment: Scalars['String']['input'];
  pipelineId: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidatePipelineNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateProjectNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateRoleNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateTemplateNameArgs = {
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryValidateUserEmailArgs = {
  email: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type QueryVersionDeployedInAllEnvironmentsArgs = {
  pipelineName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  versionMajor: Scalars['String']['input'];
};

export type QueryVersionMinorArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  realm: Scalars['String']['input'];
  versionMajor?: InputMaybe<Scalars['Int']['input']>;
};

export type Realm = {
  __typename: 'Realm';
  cluster?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalRegion?: Maybe<Scalars['String']['output']>;
  licenseModel?: Maybe<Scalars['String']['output']>;
  licenseTotal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oldPermissionRevocationDate?: Maybe<Scalars['Float']['output']>;
  oldPermissionRevoked?: Maybe<Scalars['Boolean']['output']>;
};

export type RealmInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Relationship = {
  __typename: 'Relationship';
  description?: Maybe<Scalars['String']['output']>;
  fieldNameA: Scalars['String']['output'];
  fieldNameB: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type RelationshipInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fieldNameA: Scalars['String']['input'];
  fieldNameB: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RelationshipInstance = {
  __typename: 'RelationshipInstance';
  content?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Replica = {
  __typename: 'Replica';
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReplicaInstance = {
  __typename: 'ReplicaInstance';
  name?: Maybe<Scalars['String']['output']>;
};

export type Retention = {
  __typename: 'Retention';
  scope?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['JSON']['output']>;
};

export type Role = {
  __typename: 'Role';
  custom?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

export type RoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
};

export type RolePagination = {
  __typename: 'RolePagination';
  content?: Maybe<Array<Maybe<Role>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Route = {
  __typename: 'Route';
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  destinationHost?: Maybe<Scalars['String']['output']>;
  destinationPorts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endpointGroup?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ipInterceptList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isInverse?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networkId?: Maybe<Scalars['String']['output']>;
  ports?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  protocols?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  serviceEnvironment?: Maybe<Scalars['String']['output']>;
  targetProtocol?: Maybe<Scalars['String']['output']>;
};

export type RoutesResponse = {
  __typename: 'RoutesResponse';
  hasEdgeRouter?: Maybe<Scalars['Boolean']['output']>;
  routes?: Maybe<Array<Maybe<Route>>>;
};

export type RuntimeStats = {
  __typename: 'RuntimeStats';
  dateHistogramStats?: Maybe<Array<Maybe<DateHistogramStats>>>;
  deploymentStats?: Maybe<DeploymentStats>;
  pipelineStats?: Maybe<Array<Maybe<PipelineStats>>>;
  stats?: Maybe<DateHistogramStats>;
};

export type SamlGroupMapping = {
  __typename: 'SamlGroupMapping';
  activated?: Maybe<Scalars['Boolean']['output']>;
  customSamlXPath?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  existsDeactivatedSamlGroupMapping?: Maybe<Scalars['Boolean']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastSimulationStatus?: Maybe<Scalars['String']['output']>;
  samlScheme?: Maybe<Scalars['String']['output']>;
  sourceGroupId?: Maybe<Scalars['String']['output']>;
};

export type SamlGroupMappingInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  customSamlXPath?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastSimulationStatus?: InputMaybe<Scalars['String']['input']>;
  samlScheme?: InputMaybe<Scalars['String']['input']>;
  sourceGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type SamlGroupMappings = {
  __typename: 'SamlGroupMappings';
  content?: Maybe<Array<Maybe<SamlGroupMapping>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Scope = {
  __typename: 'Scope';
  name: Scalars['String']['output'];
  selected?: Maybe<Scalars['Boolean']['output']>;
};

export type Stats = {
  __typename: 'Stats';
  runtimeStats?: Maybe<RuntimeStats>;
};

export type TelegramParams = {
  __typename: 'TelegramParams';
  chatId?: Maybe<Scalars['String']['output']>;
};

export type TelegramParamsInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
};

export type Templates = {
  __typename: 'Templates';
  canvas?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publicTemplate?: Maybe<Scalars['Boolean']['output']>;
  spec?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TemplatesInput = {
  canvas?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  publicTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  spec?: InputMaybe<Scalars['JSON']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TermAcceptance = {
  __typename: 'TermAcceptance';
  acceptanceDate?: Maybe<Scalars['Float']['output']>;
  countDown?: Maybe<Scalars['Int']['output']>;
  daysToAccept?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['Float']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  firstAccessDate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastPostponementDate?: Maybe<Scalars['Float']['output']>;
  legalRegion?: Maybe<Scalars['String']['output']>;
  refusalDate?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  termId?: Maybe<Scalars['String']['output']>;
  termType?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TestCaseInput = {
  expectedResult?: InputMaybe<Scalars['String']['input']>;
  expectedResults?: InputMaybe<Scalars['String']['input']>;
  flowSpec: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  inSpec?: InputMaybe<Scalars['JSON']['input']>;
  outSpec?: InputMaybe<Scalars['JSON']['input']>;
  payload: Scalars['String']['input'];
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type TestCaseResult = {
  __typename: 'TestCaseResult';
  assertions?: Maybe<Array<AssertionResult>>;
  id: Scalars['String']['output'];
  matchesExpected?: Maybe<Scalars['Boolean']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  testResult?: Maybe<Scalars['String']['output']>;
};

export type Token = {
  __typename: 'Token';
  token?: Maybe<Scalars['String']['output']>;
};

export type Trigger = {
  __typename: 'Trigger';
  category?: Maybe<Scalars['String']['output']>;
  configurable: Scalars['Boolean']['output'];
  documentationURL?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jsonExample: Scalars['JSON']['output'];
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TriggerCatalog = {
  __typename: 'TriggerCatalog';
  category?: Maybe<Scalars['String']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  documentationURL?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  jsonExample?: Maybe<Scalars['String']['output']>;
  keyName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shape?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  triggerCategory?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TriggerSpec = {
  __typename: 'TriggerSpec';
  addCors: Scalars['Boolean']['output'];
  advanced: Scalars['Boolean']['output'];
  allowRedelivery: Scalars['Boolean']['output'];
  basicAuth: Scalars['Boolean']['output'];
  corsHeaders?: Maybe<Scalars['String']['output']>;
  cronExpression?: Maybe<Scalars['String']['output']>;
  enableRateLimit: Scalars['Boolean']['output'];
  eventName?: Maybe<Scalars['String']['output']>;
  external: Scalars['Boolean']['output'];
  headers?: Maybe<Scalars['String']['output']>;
  internal: Scalars['Boolean']['output'];
  jwt: Scalars['Boolean']['output'];
  keyAuth: Scalars['Boolean']['output'];
  methods?: Maybe<Array<Scalars['String']['output']>>;
  mtls: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  reentrant?: Maybe<Scalars['Boolean']['output']>;
  removePrefixUri: Scalars['Boolean']['output'];
  requestSizeLimit: Scalars['Int']['output'];
  security?: Maybe<Scalars['Boolean']['output']>;
  timeout: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type TriggerSpecInput = {
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  methods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  reentrant?: InputMaybe<Scalars['Boolean']['input']>;
  requestContentTypes?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  responseContentTypes?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  security?: InputMaybe<Scalars['Boolean']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOAuthProviderFromBaseProviderInput = {
  authURL: Scalars['String']['input'];
  certificate?: InputMaybe<Scalars['String']['input']>;
  certificatePassword?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  delimiter: Scalars['String']['input'];
  grantRequestBody?: InputMaybe<Scalars['JSON']['input']>;
  grantURL?: InputMaybe<Scalars['String']['input']>;
  hasRefreshToken?: InputMaybe<Scalars['Boolean']['input']>;
  isCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  prompt: Scalars['String']['input'];
  redirect_uri?: InputMaybe<Scalars['String']['input']>;
  refreshURL?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename: 'User';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type UserAuth = {
  __typename: 'UserAuth';
  active?: Maybe<Scalars['Boolean']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  email: Scalars['String']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  preferredLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  realm?: Maybe<Scalars['String']['output']>;
  realmId?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  tokenReset?: Maybe<Scalars['String']['output']>;
};

export type UserAuthPagination = {
  __typename: 'UserAuthPagination';
  content?: Maybe<Array<Maybe<UserAuth>>>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type UserInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfile = {
  __typename: 'UserProfile';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type UserProfileInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Validate = {
  __typename: 'Validate';
  analysis?: Maybe<Scalars['JSON']['output']>;
  hasAnalysis?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidateGlobalName = {
  __typename: 'ValidateGlobalName';
  error?: Maybe<ValidateGlobalNameError>;
  isValid: Scalars['Boolean']['output'];
};

export enum ValidateGlobalNameError {
  NAME_ALREADY_EXISTS = 'NAME_ALREADY_EXISTS',
  NAME_VALIDATION = 'NAME_VALIDATION'
}

export type MessagesQueryVariables = Exact<{
  realm: Scalars['String']['input'];
  environment: Scalars['String']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  pipelineKey?: InputMaybe<Scalars['String']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  pipelineVersion?: InputMaybe<Scalars['String']['input']>;
  payloadSearch?: InputMaybe<Scalars['String']['input']>;
  jwtHash?: InputMaybe<Scalars['String']['input']>;
  jwtUser?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  searchAfterTimestamp?: InputMaybe<Scalars['String']['input']>;
  searchAfterId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  lastValue?: InputMaybe<Scalars['String']['input']>;
}>;

export type MessagesQuery = {
  __typename: 'Query';
  messages?: {
    __typename: 'MessagesResponse';
    count?: number | null;
    messages?: Array<{
      __typename: 'Message';
      id?: string | null;
      request?: string | null;
      response?: string | null;
      messageType?: string | null;
      key?: string | null;
      pipeline_name?: string | null;
      pipeline_version?: string | null;
      pipeline_source?: string | null;
      elapsed_time?: number | null;
      request_timestamp?: string | null;
      response_timestamp?: string | null;
      jwt?: string | null;
      jwt_user?: string | null;
      request_size_bytes?: string | null;
      response_size_bytes?: string | null;
      pipeline_id?: string | null;
    } | null> | null;
  } | null;
};

export type MessagesByKeyQueryVariables = Exact<{
  realm: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
}>;

export type MessagesByKeyQuery = {
  __typename: 'Query';
  messagesByKey?: Array<{
    __typename: 'MessageByKey';
    body?: string | null;
    processorStepName?: string | null;
    processorType?: string | null;
    elapsed?: number | null;
  } | null> | null;
};

export type ReexecutePipelineMutationVariables = Exact<{
  realm: Scalars['String']['input'];
  pipeName: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  environment: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;

export type ReexecutePipelineMutation = {
  __typename: 'Mutation';
  reexecutePipeline?: string | null;
};

export type LogsQueryVariables = Exact<{
  realm: Scalars['String']['input'];
  key: Scalars['String']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
  env?: InputMaybe<Scalars['String']['input']>;
  logIdAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type LogsQuery = {
  __typename: 'Query';
  logs?: Array<{
    __typename: 'Log';
    id: string;
    pipelineName: string;
    logMessage?: string | null;
    timestamp: string;
    logLevel?: string | null;
  } | null> | null;
};

export type LogsSearchQueryVariables = Exact<{
  realm: Scalars['String']['input'];
  environment?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  pipelineName?: InputMaybe<Scalars['String']['input']>;
  pipelineVersion?: InputMaybe<Scalars['String']['input']>;
  pipelineKey?: InputMaybe<Scalars['String']['input']>;
  logMessage?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  logType?: InputMaybe<Scalars['String']['input']>;
  afterDate?: InputMaybe<Scalars['String']['input']>;
  afterId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type LogsSearchQuery = {
  __typename: 'Query';
  logsSearch?: {
    __typename: 'LogsResponse';
    count?: number | null;
    logs?: Array<{
      __typename: 'Log';
      id: string;
      pipelineName: string;
      pipelineKey?: string | null;
      logMessage?: string | null;
      timestamp: string;
      timestampMillis?: string | null;
      realm?: string | null;
      logLevel?: string | null;
    } | null> | null;
  } | null;
};

export type LogSearchQueryVariables = Exact<{
  realm: Scalars['String']['input'];
  environment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
}>;

export type LogSearchQuery = {
  __typename: 'Query';
  logSearch?: {
    __typename: 'LogSearch';
    id: string;
    pipelineName?: string | null;
    pipelineKey?: string | null;
    logMessage?: string | null;
    timestamp?: string | null;
    timestampMillis?: string | null;
    realm?: string | null;
    logLevel?: string | null;
  } | null;
};

export const MessagesDocument = gql`
  query messages(
    $realm: String!
    $environment: String!
    $dateFrom: String
    $dateTo: String
    $messageType: String
    $pipelineKey: String
    $pipelineName: String
    $pipelineVersion: String
    $payloadSearch: String
    $jwtHash: String
    $jwtUser: String
    $errorCode: String
    $source: String
    $searchAfterTimestamp: String
    $searchAfterId: String
    $sortBy: String
    $direction: String
    $lastValue: String
  ) {
    messages(
      realm: $realm
      environment: $environment
      dateFrom: $dateFrom
      dateTo: $dateTo
      messageType: $messageType
      pipelineKey: $pipelineKey
      pipelineName: $pipelineName
      pipelineVersion: $pipelineVersion
      payloadSearch: $payloadSearch
      searchAfterId: $searchAfterId
      searchAfterTimestamp: $searchAfterTimestamp
      jwtHash: $jwtHash
      jwtUser: $jwtUser
      errorCode: $errorCode
      source: $source
      sortBy: $sortBy
      direction: $direction
      lastValue: $lastValue
    ) {
      messages {
        id
        request
        response
        messageType
        key
        pipeline_name
        pipeline_version
        pipeline_source
        elapsed_time
        request_timestamp
        response_timestamp
        jwt
        jwt_user
        request_size_bytes
        response_size_bytes
        pipeline_id
      }
      count
    }
  }
`;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      realm: // value for 'realm'
 *      environment: // value for 'environment'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      messageType: // value for 'messageType'
 *      pipelineKey: // value for 'pipelineKey'
 *      pipelineName: // value for 'pipelineName'
 *      pipelineVersion: // value for 'pipelineVersion'
 *      payloadSearch: // value for 'payloadSearch'
 *      jwtHash: // value for 'jwtHash'
 *      jwtUser: // value for 'jwtUser'
 *      errorCode: // value for 'errorCode'
 *      source: // value for 'source'
 *      searchAfterTimestamp: // value for 'searchAfterTimestamp'
 *      searchAfterId: // value for 'searchAfterId'
 *      sortBy: // value for 'sortBy'
 *      direction: // value for 'direction'
 *      lastValue: // value for 'lastValue'
 *   },
 * });
 */
export function useMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables> &
    ({ variables: MessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(
    MessagesDocument,
    options
  );
}
export function useMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MessagesQuery,
    MessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(
    MessagesDocument,
    options
  );
}
export function useMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MessagesQuery, MessagesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MessagesQuery, MessagesQueryVariables>(
    MessagesDocument,
    options
  );
}
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<
  typeof useMessagesLazyQuery
>;
export type MessagesSuspenseQueryHookResult = ReturnType<
  typeof useMessagesSuspenseQuery
>;
export type MessagesQueryResult = Apollo.QueryResult<
  MessagesQuery,
  MessagesQueryVariables
>;
export const MessagesByKeyDocument = gql`
  query messagesByKey($realm: String!, $key: String, $environment: String) {
    messagesByKey(realm: $realm, key: $key, environment: $environment) {
      body
      processorStepName
      processorType
      elapsed
    }
  }
`;

/**
 * __useMessagesByKeyQuery__
 *
 * To run a query within a React component, call `useMessagesByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByKeyQuery({
 *   variables: {
 *      realm: // value for 'realm'
 *      key: // value for 'key'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useMessagesByKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    MessagesByKeyQuery,
    MessagesByKeyQueryVariables
  > &
    (
      | { variables: MessagesByKeyQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessagesByKeyQuery, MessagesByKeyQueryVariables>(
    MessagesByKeyDocument,
    options
  );
}
export function useMessagesByKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MessagesByKeyQuery,
    MessagesByKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessagesByKeyQuery, MessagesByKeyQueryVariables>(
    MessagesByKeyDocument,
    options
  );
}
export function useMessagesByKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MessagesByKeyQuery,
        MessagesByKeyQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MessagesByKeyQuery,
    MessagesByKeyQueryVariables
  >(MessagesByKeyDocument, options);
}
export type MessagesByKeyQueryHookResult = ReturnType<
  typeof useMessagesByKeyQuery
>;
export type MessagesByKeyLazyQueryHookResult = ReturnType<
  typeof useMessagesByKeyLazyQuery
>;
export type MessagesByKeySuspenseQueryHookResult = ReturnType<
  typeof useMessagesByKeySuspenseQuery
>;
export type MessagesByKeyQueryResult = Apollo.QueryResult<
  MessagesByKeyQuery,
  MessagesByKeyQueryVariables
>;
export const ReexecutePipelineDocument = gql`
  mutation reexecutePipeline(
    $realm: String!
    $pipeName: String!
    $version: Int!
    $environment: String!
    $payload: JSON!
  ) {
    reexecutePipeline(
      realm: $realm
      pipeName: $pipeName
      version: $version
      environment: $environment
      payload: $payload
    )
  }
`;
export type ReexecutePipelineMutationFn = Apollo.MutationFunction<
  ReexecutePipelineMutation,
  ReexecutePipelineMutationVariables
>;

/**
 * __useReexecutePipelineMutation__
 *
 * To run a mutation, you first call `useReexecutePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReexecutePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reexecutePipelineMutation, { data, loading, error }] = useReexecutePipelineMutation({
 *   variables: {
 *      realm: // value for 'realm'
 *      pipeName: // value for 'pipeName'
 *      version: // value for 'version'
 *      environment: // value for 'environment'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useReexecutePipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReexecutePipelineMutation,
    ReexecutePipelineMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReexecutePipelineMutation,
    ReexecutePipelineMutationVariables
  >(ReexecutePipelineDocument, options);
}
export type ReexecutePipelineMutationHookResult = ReturnType<
  typeof useReexecutePipelineMutation
>;
export type ReexecutePipelineMutationResult =
  Apollo.MutationResult<ReexecutePipelineMutation>;
export type ReexecutePipelineMutationOptions = Apollo.BaseMutationOptions<
  ReexecutePipelineMutation,
  ReexecutePipelineMutationVariables
>;
export const LogsDocument = gql`
  query logs(
    $realm: String!
    $key: String!
    $time: String
    $env: String
    $logIdAfter: String
  ) {
    logs(
      realm: $realm
      key: $key
      time: $time
      env: $env
      logIdAfter: $logIdAfter
    ) {
      id
      pipelineName
      logMessage
      timestamp
      logLevel
    }
  }
`;

/**
 * __useLogsQuery__
 *
 * To run a query within a React component, call `useLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsQuery({
 *   variables: {
 *      realm: // value for 'realm'
 *      key: // value for 'key'
 *      time: // value for 'time'
 *      env: // value for 'env'
 *      logIdAfter: // value for 'logIdAfter'
 *   },
 * });
 */
export function useLogsQuery(
  baseOptions: Apollo.QueryHookOptions<LogsQuery, LogsQueryVariables> &
    ({ variables: LogsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogsQuery, LogsQueryVariables>(LogsDocument, options);
}
export function useLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LogsQuery, LogsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogsQuery, LogsQueryVariables>(
    LogsDocument,
    options
  );
}
export function useLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LogsQuery, LogsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LogsQuery, LogsQueryVariables>(
    LogsDocument,
    options
  );
}
export type LogsQueryHookResult = ReturnType<typeof useLogsQuery>;
export type LogsLazyQueryHookResult = ReturnType<typeof useLogsLazyQuery>;
export type LogsSuspenseQueryHookResult = ReturnType<
  typeof useLogsSuspenseQuery
>;
export type LogsQueryResult = Apollo.QueryResult<LogsQuery, LogsQueryVariables>;
export const LogsSearchDocument = gql`
  query logsSearch(
    $realm: String!
    $environment: String
    $dateFrom: String
    $dateTo: String
    $pipelineName: String
    $pipelineVersion: String
    $pipelineKey: String
    $logMessage: String
    $level: String
    $logType: String
    $afterDate: String
    $afterId: String
    $sortBy: String
  ) {
    logsSearch(
      realm: $realm
      environment: $environment
      dateFrom: $dateFrom
      dateTo: $dateTo
      pipelineName: $pipelineName
      pipelineVersion: $pipelineVersion
      pipelineKey: $pipelineKey
      logMessage: $logMessage
      level: $level
      logType: $logType
      afterDate: $afterDate
      afterId: $afterId
      sortBy: $sortBy
    ) {
      logs {
        id
        pipelineName
        pipelineKey
        logMessage
        timestamp
        timestampMillis
        realm
        logLevel
      }
      count
    }
  }
`;

/**
 * __useLogsSearchQuery__
 *
 * To run a query within a React component, call `useLogsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsSearchQuery({
 *   variables: {
 *      realm: // value for 'realm'
 *      environment: // value for 'environment'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      pipelineName: // value for 'pipelineName'
 *      pipelineVersion: // value for 'pipelineVersion'
 *      pipelineKey: // value for 'pipelineKey'
 *      logMessage: // value for 'logMessage'
 *      level: // value for 'level'
 *      logType: // value for 'logType'
 *      afterDate: // value for 'afterDate'
 *      afterId: // value for 'afterId'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useLogsSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    LogsSearchQuery,
    LogsSearchQueryVariables
  > &
    (
      | { variables: LogsSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogsSearchQuery, LogsSearchQueryVariables>(
    LogsSearchDocument,
    options
  );
}
export function useLogsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LogsSearchQuery,
    LogsSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogsSearchQuery, LogsSearchQueryVariables>(
    LogsSearchDocument,
    options
  );
}
export function useLogsSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LogsSearchQuery, LogsSearchQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LogsSearchQuery, LogsSearchQueryVariables>(
    LogsSearchDocument,
    options
  );
}
export type LogsSearchQueryHookResult = ReturnType<typeof useLogsSearchQuery>;
export type LogsSearchLazyQueryHookResult = ReturnType<
  typeof useLogsSearchLazyQuery
>;
export type LogsSearchSuspenseQueryHookResult = ReturnType<
  typeof useLogsSearchSuspenseQuery
>;
export type LogsSearchQueryResult = Apollo.QueryResult<
  LogsSearchQuery,
  LogsSearchQueryVariables
>;
export const LogSearchDocument = gql`
  query logSearch($realm: String!, $environment: String, $id: String) {
    logSearch(realm: $realm, environment: $environment, id: $id) {
      id
      pipelineName
      pipelineKey
      logMessage
      timestamp
      timestampMillis
      realm
      logLevel
    }
  }
`;

/**
 * __useLogSearchQuery__
 *
 * To run a query within a React component, call `useLogSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogSearchQuery({
 *   variables: {
 *      realm: // value for 'realm'
 *      environment: // value for 'environment'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLogSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    LogSearchQuery,
    LogSearchQueryVariables
  > &
    ({ variables: LogSearchQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogSearchQuery, LogSearchQueryVariables>(
    LogSearchDocument,
    options
  );
}
export function useLogSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LogSearchQuery,
    LogSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogSearchQuery, LogSearchQueryVariables>(
    LogSearchDocument,
    options
  );
}
export function useLogSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LogSearchQuery, LogSearchQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LogSearchQuery, LogSearchQueryVariables>(
    LogSearchDocument,
    options
  );
}
export type LogSearchQueryHookResult = ReturnType<typeof useLogSearchQuery>;
export type LogSearchLazyQueryHookResult = ReturnType<
  typeof useLogSearchLazyQuery
>;
export type LogSearchSuspenseQueryHookResult = ReturnType<
  typeof useLogSearchSuspenseQuery
>;
export type LogSearchQueryResult = Apollo.QueryResult<
  LogSearchQuery,
  LogSearchQueryVariables
>;
